// USA
export const locale = {
	MENU: {
		DASHBOARD: "Dashboard",
		ASIDE: {
			CUSTOMER_MANAGEMENT: "Customer Management",
			MASTER_DATA: "Master Data",
			TRANSACTION: "Transaction",
			CUSTOMER: "Customer",
			DASHBOARD: "Dashboard",
			COUNTRIES_REGION: "Countries & Region",
			COUNTRIES: "Countries",
			STATES: "States",
			CITIES: "Cities",
			LOADING: "Loading",
			INQUIRY_REPORT: "Inquiry",
			DISTRICT: "District",
			POSTCODES: "Postcodes",
			CURRENCIES_TAX: "Currencies & Tax",
			CURRENCIES: "Currencies",
			COMPANY: "Company",
			WAREHOUSE: "Warehouse",
			SALESMAN_MANAGEMENT: "Salesman Management",
			MAINSALESMAN: "Main Salesman",
			MAINTAIN: "Courier Management",
			REOPEN_CLOSE_LOADING: "Reopen/ Close SO",
			MAINTAIN_AGENT: "Maintain Agent",
			MAINTAIN_COURIER_SERVICE: "Maintain Courier Service",
			MOVEMENT_TYPE: "Movement Type",
			SHIPMENT_TERMS: "Shipment Terms",
			REFERENCE_TYPE: "Reference Type",
			CATEGORY_GROUP: "Category Type",
			COURIER_STATUS_INQUIRY: "Courier Status Inquiry",

			FORWARDER_GROUP: "Forwarder Group",
			SHIPPER: "Shipper",
			CONSIGNEE: "Consignee",
			CONSIGNEE_GROUP: "Consignee Group",
			SHIPPING_LINE: "Shipping Line",
			SALESMAN: "Salesman",
			NOTICE_TYPE_GROUP: "Notice Type Group",
			NOTICE_TYPE: "Notice Type",
			DOC_TYPE: "Doc Type",
			DOC_NUM: "Doc Numbering",

			PORT: "Port",
			UOM: "Stock UOM",
			INDUSTRIES: "Industries",
			FORWARDER: "Forwarder",

			WAREHOUSE_LOCATION: "Warehouse Location",

			DELIVERY_ADDRESS: "Delivery Address",

			SPECIAL: "Special",
			SUPPLIER: "Supplier",
			ORDER: "Order",
			INBOUND: "Status Inquiry",
			ORDER_RECEIVING: "Order Receiving",
			LOAD_CONTAINER: "Ref Id & Loading",
			CONTAINER_DETAILS: "Ref Id Details",
			CONTAINER_LOADING: "Loading",
			CONTAINER_CLOSE: "Close Receiving & Loading",
			CONTAINER_OPEN: "Reopen Receiving & Loading",
			CONTAINER_REOPEN_SO: "ReOpen S/O",
			CLOSE_CONTAINER_REOPEN_SO: "Close ReOpen S/O",
			EPO_LISTING: "EPO",
			PAYABLES: "Payable Notes",
			PAYABLES_REPORTING: "Payable Reporting",
			PAYABLE_SETTING: "Payable Notes Settings",
			PAYABLES_PAYMENT: "Payable Notes Payment",
			SYSTEM_LOG: "System Log",
			AUDIT_EMAIL_LOG: "Audit/Email Log",
			BACKEND_API_LOG: "Backend Api Log",
			GIM_API_LOG_TITLE: "GBIZS Api Log",
			EMAIL_LOG_TITLE: "Email Log",
			ORDER_RECEIVE_LOG_TITLE: "Order Receive Log",
			PRINT: "Report",
			GIMWORLD_ORDER: "Gimworld Order",
			GIMWORLD_ORDER_MAINTENANCE: "Gimworld Order Maintenance",
			POST_ORDER: "Post to Order Receiving",
			PACKING_LIST: "Packing List",
			PAYMENT_INFO: "Stock Balance Report with Payment Info",
			STOCK_REPORT_WAREHOUSE_INFO: "Stock Balance Report By Warehouse",
			ORDER_RECEIVING_SUMMARY: "Order Receiving Summary",
			MANIFEST_CONSIGNMENT_MANAGEMENT: "Manifest Consignment Management",
			DELIVERY_AGENT_ASSIGNMENT: "Courier Agent Assignment",
			CONSIGNMENT: "Consignment",

			CONSIGNMENT_AGENT_COURIER: "Consignment Agent Courier",
			CONTAINER: "Container",
			DELIVERY_AGENT: "Courier Agent",
			TRANSIT_ORDER: "Transit Order",
			SO_RECEIVE_PAYMENT: "S/O Receive Payment{notice_type}",
			MAINTAIN_TT_DEPOSIT: "TT Deposit",
			PACKING_LIST_BY_MSM: "Packing List By Msm",
			PAYMENT: "Payment",
			CLOSE_SO_RCV_PAYMENT: "Close S/O Receive Payment",
			PAYMENT_DEPOSIT: "Payment & TT Deposit",
			PAYMENT_INSTRUCTION: "S/O Payment Instruction"
		}
	},
	AUTH: {
		LOGIN: {
			TITLE: "WMS SYSTEM LOGIN",
			BUTTON: "Sign In",
			PASS_EXPIRED: "Password Expired",
			PASS_EXPIRED_DESC: "Your Password Has Expired",
			PASS_SET_NEW_PASS_BTN: "Set New Password",
			PASS_KEEP_PASS_BTN: "Remain Old Password"
		},

		INPUT: {
			EMAIL: "Email",
			FULLNAME: "Fullname",
			PASSWORD: "Password",
			CONFIRM_PASSWORD: "Confirm Password",
			USERNAME: "Username"
		},
		RESPONSE_MSG: {
			LOGIN: {
				200: "Login Successfully",
				2001: "Invalid Username or Password"
			}
		},
		RESET: {
			FIRST_TIME_LOGIN_TITLE: "Reset Your Password",
			FIRST_TIME_LOGIN_DESC: "Create a password to access your account. This will be the password you use to log in."
		}
	},
	COMMON: {
		FROM: "Date From",
		TO: "Date To",
		BTN_RESEND: "Resend",

		LBL_CREATED_BY: "Created By",
		LBL_CREATED_AT: "Creation On",
		LBL_UPDATED_BY: "Modified By",
		LBL_UPDATED_AT: "Modified On",
		LBL_STATUS: "Status",

		LBL_STATES: "State",
		LBL_CITY: "City",
		LBL_POSTCODE: "Postcode",
		LBL_ADDRESS: "Address",

		LBL_CHECKER: "Checker",
		LBL_USE_FOR_RECEIVING: "Use For EPO/Receiving",

		LBL_WAREHOUSE: "Warehouse",
		LBL_NOTICE_TYPE: "Notice Type",
		LBL_DELIVERY_ID: "Delivery Id",
		LBL_CUSTOMER_NAME: "Customer Name",
		LBL_MARKING: "Marking",
		LBL_FULL_MARKING: "Full Marking",
		LBL_TOTAL_CARTON: "Ctn",
		LBL_TOTAL_PALLET: "Pallet",
		LBL_M3: "M3",
		LBL_WEIGHT: "Kg",
		LBL_CTN: "Ctn",
		LBL_CM3: "CM3",
		LBL_MARKED_UP_M3: "Marked Up M3",
		LBL_VOL_WEIGHT: "Vol Weight",
		LBL_RECEIVE_QTY: "Receive Qty",
		LBL_RECEIVE_AMOUNT: "Receive Amount",
		LBL_RECEIVED_AMOUNT: "Received Amount",
		LBL_REF_NO: "Reference No.",
		LBL_AUTO_GENERATE: "Auto Generate",

		LBL_CURRENCY: "Currency",
		LBL_RECEIVE_DATE: "Rcv Date",
		LBL_TOTAL: "Total",
		LBL_REMARK: "Remark",
		LBL_ACTION: "Action",
		LBL_DELIVERY_ZONE: "Delivery Zone",
		LBL_REF_ID: "Ref Id",
		LBL_LOADED_DATE: "Loaded Date",
		LBL_SHIPMENT_TYPE: "Shipment Type",
		LBL_SHIPMENT_MODE: "Shipment Mode",
		LBL_SUPPLIER: "Supplier",
		LBL_COURIER_COMPANY: "Courier Company",
		LBL_SALESMAN: "Salesman",
		LBL_MAINSALESMAN: "Main Salesman",
		LBL_COMPANY_ID: "CO. ID",
		MSG_NO_DATA: "No Data",
		PH_ENTER_CREATED_BY: "Enter Created By",
		PH_ENTER_CREATED_AT: "Enter Creation On",
		PH_ENTER_UPDATED_BY: "Enter Modified By",
		PH_ENTER_UPDATED_AT: "Enter Modified On",
		PH_AUTO_DOC_NO: "Auto Generate",

		MSG_FAILED_CONNECT_SERVER: "Failed To Connect Server. Please Contact System Administrator",

		BTN_FROM_SO_RECEIVED: "Add From S/O Received",

		COL_STATUS: "Status",
		COL_AGENT: "Agent",
		COL_MODIFIEDBY: "Modified By",
		COL_MODIFIEDBYDATE: "Modified Date",
		COL_ACTION: "Action",
		COL_PUBLISH: "Publish",
		COL_MODIFIED_ON: "Modified On",
		COL_CHECKER: "Checker",
		COL_CREATED_AT: "Created On",
		COL_CREATION_BY: "Creation By",
		COL_EMAIL: "Email",
		COL_FULL_MARKING: "Full Marking",
		COL_RECEIVED_DATE: "Rvc Date",
		COL_SO_NO: "S/O No.",

		TXT_ALL: "All",
		TXT_NEW: "New",
		TXT_ERROR: "Error",
		TEXT_WARNING: "Warning",

		MSG_CONFIRM_DELETE: "Are you sure to delete?",
		DELETE_MODAL_TITLE: "Confirm Delete Record?",
		OPERATION_MSG: "Are you sure?",
		SELECTION_OPTION_TITLE: "-- Select Options --",
		SELECTION_NONE: " -- None --",
		CATEGORY_ROOT_SELECTION: " --- Category Lvl1 ---",
		CATEGORYT_SELECTION: "--- Category Lvl2 ---",
		TAX_TYPE_SELECTION: "-- Select Tax Type --",
		TAX_SELECTION: "-- Select Tax --",

		MSG_FAILED_TO_UPDATE: "{mod} has been failed edited",
		MSG_SUCCESS_TO_UPDATE: "{mod} has been successfully edited",

		MSG_FAILED_CREATE: "New {mod} has been failed to created",
		MSG_SUCCESS_TO_CREATE: "New {mod} has been successfully to created",
		MSG_FAILED_DELETE: "{mod} failed to delete",
		MSG_SUPPORT_IMAGE_SIZE_FORMAT: "Supported size should be less than 1 MB and Supported Format .jpg, .jpeg, .png",
		MSG_IMAGE_FORMAT_NOT_SUPPORTED: "Image format not supported. Supported format: .jpg, .jpeg, .png",
		MSG_REMOVE_IMAGE: "This image will be removed",
		MSG_DATA_EXIST: "Reminder: Data exists in this record - ",
		MSG_DATA_EXIST_SECOND_LINE: "The system will not allow you to save the same data record twice.",
		FAILD_UPLOAD_FILE: "Oops... ..., Failed to upload file to server. Please try again",

		MSG_SUCCESS_TO_DELETE: "{mod} record successful to delete",
		PH_DROP_FILE: "Choose a file or drop it here...",
		DROP_PH_DROP_FILE: "Drop file here...",
		MSG_INVALID_EMAIL: "Invalid Email",
		MSG_NOT_ALLOW_DELETE: "Ooops, You are not allow delete this {mod} record",
		LBL_COUNTRIES: "Country",
		LBL_STATES: "State",
		LBL_CITY: "City",
		LBL_POSTCODE: "Postcode",
		LBL_STOCK_ID: "Stock Id",
		LBL_STOCK_DESC1: "Stock Desc1",
		LBL_STOCK_DESC2: "Stock Desc2",
		LBL_UOM: "Uom",
		LBL_ITEM_CODE: "Item Code",
		LBL_WAREHOUSE_LOCATION: "Warehouse Location",

		SELECT_ALL_TITLE: "Select All",
		YES_STATUS_VAL: "Yes",
		NO_STATUS_VAL: "No",
		SELECTION_OTHERS: "Others",

		RATE_TYPE_SELECTION: {
			FIX_AMOUNT: "Fix Amount",
			RATE_BY_AMOUNT: "Rate By Amount",
			RATE_BY_PERCENTAGE: "Rate By Percentage"
		},
		EMPTY_SPACE: "",

		FORMULA_SELECTION: {
			BASE_RATE: "Base Rate",
			MULTIPLE_RATE: "Multiple Rate"
		},

		MSG: {
			MSG_ERROR_TITLE: "Oops...",
			MISSING_DOC_TYPE: "Document Type is not set.",
			MSG_BEFORE_LEAVE_PAGE: "Changes you made may not saved. If you leave page, these changes will be lost.",
			MSG_BEFORE_LEAVE_PAGE_TITLE: "Are you sure you want to leave this page?",
			NOT_FOUND: "{name} not found",
			API_SERVICE_ERROR: "System Error, Please assist System Admin.",
			SUCCESSFUL_SAVE: "Successful save record",
			ARE_YOU_SURE: "Are You Sure?",
			MSG_UNABLE_UPLOAD_IMAGE: "Unable upload image. Please try again"
		},

		VALIDATION: {
			INVALID: "{name} is not valid",
			REQUIRED: "{name} is required",
			MIN_LENGTH: "{name} minimum length is {min}",
			AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
			NOT_FOUND: "The requested {name} is not found",
			INVALID_LOGIN: "The login detail is incorrect",
			REQUIRED_FIELD: "Required field",
			MIN_LENGTH_FIELD: "Minimum field length:",
			MAX_LENGTH_FIELD: "Maximum field length:",
			INVALID_FIELD: "Field is not valid",
			NUMBER: "{name} must be number",

			INVALID_WARNING_MSG: "Please, provide correct data!",
			DUPLICATE_ENTRY: "{name} is duplicate. Please Try Again",
			UNIQUE_FIELD: "{name} must be unique.",
			DOCUMENT_NUMBERING_NOT_SET: "Document Number Format is not found. Please setup first.",
			ID_NOT_FOUND: "Record not found",
			GREATER_THAN_ZERO: "{name} must be greater than 0",
			PASSWORD_DOESNT_MEET_COMPLEXITY_REQUIREMENTS: "The password doesn't meet the complexity requirements",
			IS_EMPTY: "{name} is empty."
		},

		SEARCHFORM: {
			LBL_MARKING: "Marking",
			LBL_MAIN_SALESMAN: "Main Salesman",
			LBL_SALESMAN: "Salesman",
			LBL_AGENT: "GBizs Agent",
			LBL_WAREHOUSE: "Warehouse",
			LBL_SHIPMENT_TYPE: "Shipment Type",
			LBL_QUOTATION_NO: "Quotation No.",
			LBL_CUSTOMER_NAME: "Customer Name",
			LBL_DELIVERY_ID: "Delivery Id",
			LBL_COMPANY: "Company",
			LBL_COMPANY_GROUP: "Company Group"
		},
		NEW_TITLE: "New",
		SUMMARY_COL: {
			COL_MSM_CODE: "Msm",
			COL_SM_CODE: "Sm",
			COL_COMPANY_GRP: "Comp. Sub Grp",
			COL_MARKING: "Marking",
			COL_FULL_MARKING: "Full Marking",
			COL_DELIVERY_ID: "Del. Id",
			COL_CUSTOMER_NAME: "Customer Name",
			COL_AGENT: "Gbizs Agent",
			COL_WAREHOUSE: "Wh",
			COL_SHIPMENT_TYPE: "Shipt. Type",
			COL_SHIPMENT_MODE: "Shipt. Mode",
			COL_COUNTRY: "Country"
		},

		ADDRESS: {
			LBL_ADDRESS: "Address",
			LBL_UPSTAIRS: "Move Upstairs"
		},
		STATUS_INQUIRY: {
			NO_CHECKER: "Please Select a Checker",
			VALIDATION_CHERCKER: "Required to pick a Checker"
		}
	},
	ORDER: {
		INBOUND: {
			MODULE_NAME: "Status Inquiry",
			CHECK_SELCTED_ROW: "⚠ Some selected rows have missing S/O number, Delivery ID, or Marking ID",
			SCRAPED_RECORD: "Scraped Record",
			SCRAP_BTN: "Scrap",
			EXCLUDE_SCRAPED_RECORRD: "Excluded",
			INCLUDE_SCRAPED_RECORRD: "Included",
			RECORD_SCRAPED: "This record has been scraped, due to: {reason}",
			ONLY_SCRAPED_RECORRD: "Scraped Only",
			REVERT_BTN: "Revert",
			SCRAP_STATUS: "Scrap Status",
			SCRAP_BY: "Scraped By",
			SCRAP_AT: "Scraped At",
			REVERT_BY: "Reverted By",
			REVERT_AT: "Reverted At",

			COURIER_STATUS_INQUIRY_MODULE: "Courier Status Inquiry",
			LISTING_TITLE: "Status Inquiry Listing",
			COURIER_LISTING_TITLE: "Courier Status Inquiry Listing",
			EXCLUDE_ASSIGN_CHECKER: "Exclude Assign Checker",
			MISSING_SO: "Missing S/O",
			CREATE_TITLE: "Create New Status Inquiry",
			CREATE_COURIER_TITLE: "Create New Courier Status Inquiry",
			DETAIL_TITLE: "Status Inquiry Detail",
			COURIER_DETAIL_TITLE: "Courier Status Inquiry Detail",
			EDIT_TITLE: "Edit Status Inquiry Detail",
			COURIER_EDIT_TITLE: "Edit Courier Status Inquiry Detail",
			PRINT_GRN_RECEIPT: "GRN A4",
			GRN_RECEIPT: "GRN Receipt",
			PRINT_CTN_LABEL: "Print CTN Label",
			PRINT_PO_LABEL: "Print PO Label",
			PRINT_EPO: "Print EPO",
			SHARED_SO_TITLE: "Shared S/O",
			REMARK: "Remark",
			CHECKER: "Checker",
			SUPPLIER_LIST: "Suppliers",
			DRIVER_LIST: "Drivers",
			SUPPLIER_DETAILS: "Supplier Info",
			SUPPLIER: {
				DETAILS: "Supplier Master Data",
				CONTACT: "Supplier Contact",
				DRIVER_NAME: "Driver Name",
				DRIVER_CONTACT: "Driver Contact",
				DRIVER_CONTACT_CALLING_CODE: "Driver Contact Calling Code",
				SUPPLIER_NAME: "Supplier Name",
				SUPPLIER_CONTACT: "Supplier Contact",
				SUPPLIER_CONTACT_CALLING_CODE: "Supplier Contact Calling Code",
				BANK_ACC_NAME: "Bank Account Name",
				BANK_ACC_NO: "Bank Account No."
			},
			MSG: {
				SUPPLIER_NOT_FOUND: "Supplier not existed.",
				DRIVER_NOT_FOUND: "Driver not existed for supplier.",
				SCRAPED_RECORD: "Record Scraped",
				NOT_ALLOW_EDIT: "Record is Scraped Not Allow to Edit the Record",
				REVERTED_RECORD: "Record Reverted",
				COMFIRM_SCRAP: "Are you sure to scrap ?",
				COMFIRM_REVERT: "Are you sure to revert ?",
				CONFIRM_SAVE_SUPPLIER: "Are you sure you want to save this as new supplier : {supplier}",
				CONFIRM_SAVE_DRIVER: "Are you sure you want to save this as new driver detail for supplier : {supplier}",
				EPO_NOT_FOUND: "EPO Not Found, cannot receive",
				SPECIAL_INS_FAILED: "Fail to get special instruction.",
				PLT_CTN_EMPTY: "Pallet/Carton Number cannot be empty",
				RECEIVED_AMT_EMPTY: "Received Amount cannot be empty",
				CHECKER_NOT_SELECTED: "Checker is required to print CTN Label",
				COURIER_COMPANY_ID_MISSING: "Courier company id is missing",
				CONSIGNMENT_NO_MISSING: "Consignment no is missing",
				CONSIGNMENT_NO_EXISTS: "Consignment no exists.",
				CONFIRM_EDIT_SO_NO: "Are you sure you want to edit this S/O No?",
				SO_NO_NOT_SELECTED: "S/O No. not selected.",
				COURIER_COMPANY_NOT_SELECTED: "Courier Company not selected",
				REMAIN_CONSIGNMENT: "Would you like to remain currently selected consignment details?",
				SELECT_TO_SCRAP: "Select {label}: <b>{value}</b> to scrap.",
				ENTER_TO_SCRAP: "Enter {label}: <b>{value}</b> to scrap.",
				PRINT_ARRANGED_SO_CONFIRMATION_TITLE: "The following S/O No are not fully arranged: </br> {so_no}",
				IS_RECEIVED: "S/O No.: {so_no} has been received, cannot be edited",
				NOT_DATA_FILTER_WAREHOUSE: "No access to create {warehouse_code} warehouse record. Please contact Admin.",
				FAILD_SELECT_ROW: "Fail to get selected row detail,Please try again !"
			},
			SAVE_NEW_DRIVER: "New Driver",
			SAVE_NEW_SUPPLIER: "New Supplier",
			CONFIRMATION_CONTINUE_RECEIVE: "Epo: {epo_no} request to stop receive.<br />Are You Sure to continue receiving?",
			CONFIRMATION_DUPLICATE_SO_NO: "Inbound with same So No exists.<br />Are You Sure to continue receiving?",
			CONFIRMATION_DIFFERENT_COURIER: "The S/O No has different courier company.<br />Are You Sure to continue receiving?",
			SUPPLIER_EXISTS: "Supplier existed: {supplier_name}. Please use a different supplier name.",
			DRIVER_EXISTS: "Driver existed: {driver_name}. Please use a different driver name.",
			BLANK_SO_NO: "No S/O No.",
			SHARED_SO: "Shared S/O No.",
			SHARED_SO_DUPLICATE: "Shared S/O No cannot contain current S/O No",
			VERSION: "Version",
			COURIER: "Courier",
			CONSIGNMENT_NO: "Consignment No",

			COL_WAREHOUSE_LOCATION: "Warehouse Location",
			COURIER_COMPANY: "Courier Company",
			OTHER_COURIER_COMPANY: "Other Company",
			EDIT_COURIER_CONSIGNMENT: "Edit Courier Detail",
			EDIT_CTN_REMARK: "Edit Ctn/Remark",
			ARRANGED_SO: "Arranged S/O",
			EXCLUDE_ARRANGED_SO: "Exclude",
			INCLUDE_ARRANGED_SO: "Include",
			ONLY_ARRANGED_SO: "Only Arranged S/O",
			EXCLUDE_COURIER: "Exclude Courier Status Inquiry",
			COL_COURIER: "From Courier",
			SO_NO_SELECTION: "S/O No Selection",
			NOT_SAME_DETAILS: "{name} not same as selected",
			DIFFERENT_COURIER_EPO_SELECTION: "EPO with selected Courier and Consignment No does not exist.<br/>Below are other EPOs with same Consignment No.",
			SCRAP_REASON: "Reason",
			VIEW_CONSIGNMENT_SO_DETAIL: "View Consignment S/O Detail",
			ARRANGED_DATE: "Arranged Date",
			ARRANGED_DATE_FROM: "Enter Arranged Date From",
			ARRANGED_DATE_TO: "Enter Arranged Date To",
			PRINT_ARRANGED_SO_BTN: "Print Arranged S/O",
			PRINT_ARRANGED_SO: {
				COL_WAREHOUSE_LOCATION: "Wh Location"
			}
		},
		ORDER_RECEIVING: {
			MENT_NAME: "Order Receiving",
			LISTING_TITLE: "Order Receiving Listing",
			CREATE_TITLE: "Create New Order Receiving",
			DETAIL_TITLE: "Order Receiving Detail",
			EDIT_TITLE: "Edit Order Receiving Detail",
			CHANGE_SO_DETAIL_TITLE: "Change {so_no} Detail",
			LOADING_DETAIL_TITLE: "S/O No.: {so_no}  Loading Details",

			DELIVERY_ZONE: "Delivery Zone",
			CATEGORY_TYPE: "Category Type",
			DROPAT: "DropAt",
			RECEIVED_AMT: "Received Amt",
			CASH_PAYMENT: "Cash Payment",
			MY_PAID_AMOUNT: "My Paid Amount",
			PAYMENT_ON_AMOUNT: "Payment On amount",
			PAID_INDICATOR: "Is Paid",
			IS_CLOSE: "Is Close",
			BAL_AMT: "Bal Amt",
			PAYABLE_NOTE_NO: "Payable Note No. / GRN No.",
			TTL_ITEM: "Ttl Item",
			DEPOSIT: "Deposit",
			CTN: "Ctn",
			CTN_PER_PLT: "Ctn / Pallet",
			PLT: "Pallet.",
			ONLY_HAS_WAREHOUSE_CHARGES: "Has Warehouse Charges Only",

			COURIER_COMPANY_NAME: "Courier Company Name",
			CONSIGNMENT_NOTE_NO: "Consignment Note Number",

			KG: "Kg",
			M3: "M3",
			CUSTOMER_M3: "CM3",
			REMARK: "Remark",
			CREDIT_TERM: "Credit Term",
			IS_SENSITIVE: "Is Sensitive ?",
			ORDER_RECEIVING_DETAILS_CANNOT_BE_EMPTY: "Order Receiving Details cannot be empty",
			BALANCE_AMOUNT_CANNOT_LESS_THAN_ZERO: "FCP / PN amount cannot less than zero, please check.",
			VERSION: "Version",
			SENSITIVE: "Sensitive",
			PARCEL_LOST_GUARANTEE: "Parcel Guarantee",
			NO_TAX: "0TX",
			IS_ZERO_TAX: "Is 0TX?",
			DUE_DAYS: "Due Days",
			SO_CUS_DEPOSIT: "SO CUS Deposit",
			SO_SUP_DEPOSIT: "SO SUP Deposit",
			TOTAL_DIMENSION: "Total Dimension",
			DIMENSION: "Dimension",
			DCP_AMOUNT: "DCP Amount",
			VIEW_FCP_CP: "View FCP/CP (TT (0.00/0.00)",
			INSTRUCTION_BY_MARKING: "Instruction By Marking",
			INSTRUCTION_BY_SO: "Instruction By SO",
			REMARK2: "Remark2",
			MY_PAID: "My Paid",
			OTHER_AMOUNT: "Sup WH Disc",
			FCP_AMOUNT: "FCP Amount",
			COL_FCP_AMOUNT: "FCP Amt",
			DISCOUNT_AMOUNT: "Discount Amount",
			BALANCE_AMOUNT: "Balance Amount",
			RECEIVED_AMOUNT: "Received Amount",
			PN_AMT: "PN Amt",
			STICKER_FEES_PER_CARTON: "Sticker Fees / Ctn",
			STICKER_FEES: "Sticker Fees",
			PAID_BY_SUP: "Paid By Sup?",
			SUPPLIER_PAY_AMOUNT: "Supplier pay Amount",
			CTN_NO: "CTN No.",
			CONFIRM_SAVE_BENE_MASTER: "Are you sure want to save these beneficiary details as new master record?",

			BENE_MASTER_SAVED: "New beneficiary info created successfully",
			PRINT_GRN: "Print GRN",
			PRINT_PN: "Print Payable Notes",
			PRINT_PO_LABEL: "Print PO Label",
			PRINT_CTN_LABEL: "Print Ctn Label",
			EPO_LIST: "Epo Listing",
			ACTION: "Action",
			REMARKS: "Remarks",
			EPO_DATE: "EPO Date",
			EPO_AMOUNT: "EPO Amount",
			CAN_RECEIVE_AMOUNT: "Can Receive Amount",
			CALLING_CODE: "Calling code",
			EDIT_REMARK: "Edit Remark",
			EDIT_REMARK2: "Edit Remark2",
			ID: "id",
			TOTAL_QTY: "Total qty: {qty}",
			RECEIVED_QTY: "Received qty: {received_qty}",
			FILE: "File",
			COMPANY_ID: "COMPID",
			AGENT_ID: "agent id",
			IMPORT_EXCEL_FILE: "Import Excel File",
			TRANSIT: "Need Transit?",
			TRANSIT_WAREHOUSE: "Transit Warehouse",
			IS_TRANSIT: "Is Transit",
			APPLY_TO_ALL: "Apply Stock ID",
			DEPOSIT_TITLE: "S/O No: {so_no} Deposit",
			TTL_RCV_QTY: "Ttl Rcv Qty",
			TTL_LOADED_QTY: "Ttl Loaded Qty",
			LOADED_QTY: "Loaded Qty",
			LOADED_KG: "Loaded Kg",
			LOADED_M3: "Loaded M3",
			LOADED_CTN: "Loaded Ctn",
			DIFFERENT_DUE_DAYS_TITLE: "Confirm to update due days?",
			PREVIOUS_DUE_DAYS: "Previous Due Days",
			NEW_DUE_DAYS: "New Due Days",
			DIFFERENT_DUE_DAYS_CONTENT: "<br/>Do you want to replace the due days with the new due days or remain previous due days?",

			MSG: {
				EPO_NOT_FOUND: "EPO : {epo} Not Found, please make sure you enter the EPO correctly",
				EPO_NOT_INBOUND: "EPO : {epo} not yet Status Inquiry, please contact Status Inquiry PIC",
				NO_NEW_INBOUND: "EPO : {epo} existing Status Inquiry has been received, please contact Status Inquiry PIC",
				FULLY_RECEIVED: "EPO : {epo} has been fully received.",
				SO_RECEIVED: "This EPO has been partially received.",
				CANNOT_SAVE_BENE_MASTER: "Supplier not exist in master, bank info will not be able to save as master data.",
				CTN_M3_MUST_HAVE_VALUE: "Ctn & M3 must be greater than 0",
				AIR_SHIPMENT_TYPE_WEIGHT: "Air Shippment Kg must be greater than 0",
				CONFIRMATION_DIMENSION_NOT_TATLLY: "Total Dimension not equally total M3. Are you sure to continue?",
				BENE_EMPTY_DETAIL: "Bene details is empty. Are you sure to continue?",
				AVAIBLE_RECEIVE_QTY: "Available quantity smaller than received quantity. Are you sure to continue?",
				REQUIRE_INBOUND: "Inbound is required.",
				PLEASE_SELECT_WAREHOUSE: "Please select warehouse.",
				SPECIAL_INS_FAILED: "Failed to get special instruction.",
				NON_CONSIGNMENT_DETAILS_NOT_EXIST: "S/O No.: {epo} product details require Consignment No.",
				NON_CONSIGNMENT_DETAILS_FULLY_RECEIVED: "Non consignment details for S/O No.: {epo} is fully received",
				CONFIRMATION_DUPLICATE_SO_NO: "Order Receive with same So No exists.<br />Are You Sure to continue receiving?",
				EPO_ID_NOT_FOUND: "EPO not found, might have been deleted",
				INBOUND_ID_NOT_FOUND: "Status Inquiry not found, might have been scrapped",
				DOC_TYPE_CODE: "<strong>Doc Type Code:</strong> {doc_type_code}",
				SUCCESS_EDIT: "Successfully edited {field}",
				CANNNOT_EDIT: "This record has been loaded, and cannot be edited.",
				SUPPLIER_EXISTS: "Supplier existed: {supplier_name}. Please use a different supplier name.",
				DIFFERENT_FROM_ENTERED: "{label} is different from entered.",
				EXCEL_EMPTY_FIELD: "{label} field in Excel file is empty.",
				EXCEL_FIELD_INVALID: "{label} field in Excel file is invalid.",
				IMPORT_FAILED: "Failed To Import",
				SHIPMENT_MODE_REQUIRED: "Shipment Mode is required with Shipment Type",
				RESELECT_FILE: "Please reselect the file and resubmit.",
				CONFIRM_EDIT_SO_NO: "Are you sure you want to edit this S/O No?",
				DEPOSIT_MORE_THAN_ONE: "More than one {label} found: ",
				DEPOSIT_DIFFERENT_FROM_SELECTED: "{label}: {value} is different from selected",
				SHIPMENT_TYPE_ERROR: "Error occured while setting default shipment type, please manually select shipment type",
				CONFIRM_EDIT_FCP_AMOUNT: "Are you sure you want to edit FCP amount?",
				CHANGE_CATEGORY: "Are you sure to change Stock Id?",
				DELETE_ALL_CONFIRMATION: "Are you sure you want to delete all items?",
				STOCK_ID_NOT_FOUND: "Stock Ids not found: {codes}",
				SO_PAYMENT_MADE: "This S/O has made payment.",
				BALANCE_LESS_THAN_PAYMENT_MADE: "The balance amount is less than the payment made.",
				DIFFERENT_NOTICE_TYPE_ID: "The notice type for this new marking is different from the previous marking notice type. Please contact Admin to perform this change.",

				ALL_ITEMS_TRANSITED: "All items in So No. {so_no} have already been transited, and cannot be edited."
			},

			DETAILS: {
				ADD: "Add",
				ERROR_ASCII: "Only ASCII characters are allowed",
				PACKING_T: "Packing T",
				LINE_NUMBER: "Line No",
				INVOICE_DESC: "Invoice Desc",
				BUYING_PRICE: "Buying Price",
				RECEIVED_AMT: "Received Amt",
				OTHER_AMT: "WH Chgr Amt",
				DISCOUNT: "Discount",
				DEPOSIT: "Deposit",
				SUPPLIER_DEPOSIT: "Supplier Deposit",
				VOUCHER: "Voucher",
				REF_ID: "Ref ID",
				LOAD_Q: "Load Q",
				CLOSE: "Close",
				INV: "Inv",
				DO: "D/O",
				STK_MAST: "Stk Mast",
				VERSION: "Version",
				WAREHOUSE: "Warehouse",
				BLANK_SO_NO: "Blank S/O No",
				CPO_NO: "CPO No"
			},
			DIMENSION_LIST: {
				ADD: "Add",
				STICKER_FROM: "Sticker From",
				STICKER_TO: "Sticker To",
				LENGTH: "Length<br />(cm)",
				WIDTH: "Width <br />(cm)",
				HEIGHT: "Height <br />(cm)",
				TERTIARY_PACKING: "Tertiary Packing",
				SECONDARY_PACKING: "Secondary Packing",
				CTN_PER_PLT: "Ctn / pallet",
				PLT: "Pallet",
				CTN: "Ctn",
				KG: "Kg",
				M3: "M3",
				TTL_M3: "TTL M3",
				TTL_KG: "TTL Kg",
				REMARK: "Remark",
				KG_NOT_TALLY: "Dimension List KG is not tally",
				CTN_NOT_TALLY: "Dimension List CTN is not tally",
				M3_NOT_TALLY: "Dimension List M3 is not tally"
			},

			PREVIEW_PN: "Preview Payable Note {pn_no}",
			GRN_NO: "GRN No.",
			CONSIGNMENT_NO: "Consignment No",
			EXCEL: {
				MSM: "MSM",
				SM: "SM",
				MARKING: "MARKING",
				DEL_ID: "DEL ID",
				SO_NO: "P/O SO NUMBER",
				CUR_ID: "Cur ID",
				RECEIVE_DATE: "Receive Date",
				SUPPLIER_ID: "Supplier ID",
				WAREHOUSE: "Warehouse",
				COMPANY_ID: "COMPID",
				IS_SENSITIVE: "Is Sensitive?"
			},

			COL: {
				WH_CHRG_AMT: "WH Chrg",
				SO_SUP_DEPOSIT: "Supplier Deposit",
				MY_PAID: "My Paid"
			},

			BTN_CHANGE_MARKING_CURRENCY: "Change Marking/Del.ID/Currency",
			BTN_LOADING_DETAILS: "Loading Details",
			LBL_UPDATE_SO_NO: "Update S/O No.",
			LBL_UPDATE_STATUS_INQUIRY: "Update Status Inquiry",
			LBL_UPDATE_CURRENCY: "Update Currency",
			LBL_IS_SHARED_SO: "Is Shared S/O",
			LBL_UPDATE_MARKING: "Update Marking / Del ID"
		},
		TRANSIT_ORDER: {
			MODULE_NAME: "Transit Order",
			TITLE_SELECT_SO: "Select Transit S/O",
			TITLE_RECEIVE_ORDER: "Recevied {ref_no} order",
			TITLE_PACKING_LIST: "{ref_no} Packing List",

			LBL_RECEIVE_WAREHOUSE: "Transit Warehouse",

			LBL_DELIVERY_DATE: "Delivery Date",
			LBL_RECEIVE_DATE: "Receive Date",

			LBL_RECEIVE_STATUS: "Receive?",

			LBL_TRANSIT_QUANTITY: "Transit Quantity",
			LBL_TRANSIT_AMOUNT: "Transit Amount",

			LBL_TRANSITED_QUANTITY: "Transited Quantity",
			LBL_TRANSITED_AMOUNT: "Transited Amount",

			LBL_BAL_QUANTITY: "Bal. Qty",
			LBL_BAL_AMOUNT: "Bal. Amt",
			LBL_BAL_CTN: "Bal. Ctn",
			LBL_BAL_M3: "Bal. M3",
			LBL_BAL_KG: "Bal. Kg",

			MSG_TRANSIT_ORDER_REQUIRED: "S/O Detail(s) is required.",
			MSG_ORDER_RECEIVE_BLOCKED_DELETE: "{ref_no} was received. You are not allow to delete.",
			MSG_LOADED_ITEM_EXISTS_BLOCKED_DELETE: "{ref_no} contains loaded items. You are not allow to delete.",
			MSG_CONFIRM_PRINT_PACKING_LIST: "Continue Print Packing List. <br />Press 'Yes' to Continue.<br/>Press 'No' to Cancel.",

			BTN_PACKING_LIST: "Packing List",
			BTN_RECEIVE: "Receive"
		},
		CONSIGNMENT: {
			DELIVERY_AGENT_ASSIGNMENT: {
				MODULE_NAME: "Courier Agent Assignment",
				LISTING_TITLE: "Courier Agent Assignment Listing",
				REF_ID: "Ref ID",
				CREATED_DATE: "Created Date",
				CREATED_DATE_FROM: "Created Date From",
				CREATED_DATE_TO: "Created Date To",
				CONTAINER_COURIER_SERVICE: "Courier Company",
				DELIVERY_AGENT: "Courier Agent",
				CONTAINER_DELIVERY_AGENT: "Courier Agent"
			},
			MANIFEST_CONSIGNMENT: {
				MODULE_NAME: "Manifest Consignment",
				LISTING_TITLE: "Manifest Consignment Management Listing",
				CREATE_TITLE: "Create New Manifest Consignment",
				DETAIL_TITLE: "Manifest Consignment Detail",
				EDIT_TITLE: "Edit Manifest Consignment",
				SEND_DATE: "Send Date",
				DOC_DATE: "Doc Date",
				QTY: "Qty",
				CTN: "Ctn",
				TTL_CTN: "TTL CTN",
				TTL_W: "TTL W",
				TTL_M3: "TTL M3",
				KG: "Kg",
				M3: "M3",
				DIMENSION: "Dimension (cm)",
				OVER_LENGTH: "Over Length",
				CTN_DIMENSION: "Ctn Dimension",
				IS_SENSITIVE: "Is Sensitive ?",
				CONSIGNMENT_TYPE: "Consignment Type",
				CONSIGNMENT_NAME: "Consignment Name",
				CONSIGNMENT_ADDRESS: "Consignment Address",
				CONSIGNMENT_CONTACT: "Consignment Contact",
				CONSIGNMENT_TEL_NO: "Consignment Tel No.",
				CONSIGNMENT_TEL_NO_CALLING_CODE: "Consignment Tel No. Calling Code",
				GOODS_DESCRIPTION: "Goods Description",
				COURIER_AGENT: "Courier Agent",
				COURIER_COMPANY: "Courier Company",
				DETAIL_SELECTION_TITLE: "Select Product Details",
				DOWNLOAD_MANIFEST: "Download Manifest",
				GOODS_CAPTION_TYPE: "Goods Caption Type",
				SENSITIVE_TYPE: "Sensitive",
				NORMAL_TYPE: "Normal",
				IMPORT_MANIFEST: "Import Manifest",
				IMPORT_MANIFEST_TITLE: "Import Manifest Excel File",
				MANIFEST_CONSIGNMENT_DETAIL: "Manifest consignment detail",
				ORIGINAL_EXPRESS_NO: "Original Express No: {ids}",
				FILE: "File",
				CUST_REF: "CUST_REF",
				MIXED: "Mixed",
				UNDO_DOWNLOAD: "Undo Download",

				LENGTH: "Length",
				WIDTH: "Width",
				HEIGHT: "Height",
				VOLUME_WEIGHT: "Volume Weight",
				ADD_FROM_SO_RECEIVED: "Add from SO Received",
				LBL_DIMENSION_BUTTON: "Dimension",
				TOTAL_DIMENSION: "Total Dimension",

				MSG: {
					ORDER_RECEIVING_DETAILS_NOT_FOUND: "{ref_id} details record not found",
					EMPTY_CONTAINER: "Container is empty",
					EMPTY_KG_CONFIRMATION: "Some of the Kg fields are empty, continue save?",
					DELIVERY_ZONE_NOT_SET: "Delivery zone with following details not set",
					NOT_ALLOW_EDIT: "The manifest has been downloaded, and cannot be edited.",
					DELIVERY_AGENT_COURIER_LINKAGE_NOT_SET: "Courier agent with following details not set",
					GOODS_CAPTION_NOT_SET: "Goods Caption not set",
					IMPORT_MANIFEST_SUCCESSFUL: "Import Manifest Successful",
					HEADER_LENGTH_INCORRECT: "File header has missing or extra fields",
					INCORRECT_HEADER: "File header is incorrect",
					FILE_EMPTY_DETAILS: "Imported file does not have any details",
					EMPTY_FILENAME: "Filename cannot be empty",
					INCORRECT_CUSTOMER_CODE: "Customer code on filename is incorrect",
					REF_ID_NOT_EXIST: "Ref Id on filename does not exist",
					INCORRECT_FILENAME_FORMAT: "filename must be in [Customer code]-[Ref Id] format",
					CUST_REF_NOT_FOUND: "CUST_REF not found: {cust_ref}",
					ISSUE_OCCURED: "Issue occured while uploading the file, please reselect the file and try again.",
					HAS_CONSIGNMENT_NO: "The record already has consignment no, cannot undo download.",
					UNDO_DOWNLOAD_SUCCESS: "Successfully undone download.",
					EMPTY_CONSIGNMENT_NO: "Consignment No are empty in the following rows: {rows}.",
					FILENAME_FORMAT: "Filename must be in [Customer code]-[Ref Id] format. </br> Example: 600655-REF123456.xlsx, 350140-REF123456.xls",
					HAS_IMPORTED_BEFORE: "Unable to import, the manifest for Ref Id: {ref_id} has imported before.",
					NO_RECEIVE_RECORD: "No SO Received Record",
					REF_ID_EXISTS: "Ref Id exists"
				}
			},
			CONSIGNMENT_AGENT_COURIER: {
				MENT_NAME: "Consignment Agent Courier",
				LISTING_TITLE: "Consignment Agent Courier Listing",
				CREATE_TITLE: "Create New Consignment Agent Courier",
				DETAIL_TITLE: "Consignment Agent Courier Detail",
				EDIT_TITLE: "Edit Consignment Agent Courier",
				REF_ID: "Ref ID",
				AGENT_ID: "Agent ID",
				COURIER_ID: "Courier ID",
				ORDER_DATE: "Order Date",
				COLLECT_DATE: "Collect Date",
				SHIPMENT_MODE: "Shipment Mode"
			}
		},
		PAYMENT_INSTRUCTION: {
			MODULE_NAME: "S/O Payment Instruction",
			COL_INSTRUCTION_REF_NO: "Instruction Ref No",
			COL_INSTRUCTION_DATE: "Instruction Date",
			COL_ENTER_INSTRUCTION_DATE_TO: "Instruction Date To",
			COL_ENTER_INSTRUCTION_DATE_FROM: "Instruction Date From",
			COL_SO_AMT: "So Amt",
			COL_PAID_AMT: "Paid Amt",
			COL_BALANCE_AMT: "Bal Amt",
			COL_CANCEL_AMT: "Cancel Amt",
			COL_EXTRA_AMT: "Extra Amt",
			COL_AR_REMARK: "AR Remark",
			COL_ACKNOWLEDGE_REMARK: "Acknowledge Remark",
			COL_REQUEST_REVERT_REMARK: "Request Revert Remark",
			COL_REVERT_ACKNOWLEDGE_REMARK: "Revert Remark",
			LBL_INSTRUCTION_STATUS: "Instruction Status",

			LBL_ACKNOWLEDGE_MODULE_NAME: "Acknowledge Payment Instruction By S/O",
			LBL_REVERT_ACKNOWLEDGE_MODULE_NAME: "Revert Acknowledge Payment Instruction By S/O",

			BTN_ACKNOWLEDGE: "Acknowledge",
			BTN_REVERT: "Revert",
			MSG_SUCCESS_TO_ACKNOWLEDGE: "Ref No.: {ref_no} has been acknowledge successfully.",
			MSG_SUCCESS_TO_REVERT: "Ref No.: {ref_no} has been reverted successfully."
		},
		SO_RECEIVE_PAYMENT: {
			MODULE_NAME: "S/O Receive Payment ({notice_type})",
			SELECT_SO_RECEIVE_TITLE: "Select S/O Receive List",
			SELECT_SUPPLIER_TITLE: "Select Supplier Bene",

			LBL_REQUEST_AMOUNT: "Request Amt",
			LBL_DUE_DAY: "Due Days",
			LBL_DUE_DATE: "Due Date",
			LBL_TOTAL_RECEIVE: "Ttl. Rcv",
			LBL_DISCOUNT_AMOUNT: "Disc. Amt",
			LBL_SO_SUP_DEPOSIT: "Sup. Deposit",
			LBL_SO_CUS_DEPOSIT: "Cus. Deposit",
			LBL_CASH_PAYMENT: "Cash Amt",
			LBL_MY_PAID: "My Paid",
			LBL_SUP_WH_DISC: "Sup WH Disc",
			LBL_STICKER_FEES: "Sticker Fees",
			LBL_FCP_AMOUNT: "Fcp Amt",
			LBL_PN_AMOUNT: "PN. Amt",
			LBL_REQUESTED: "Requested",
			LBL_BALANCE_AMOUNT: "Bal. Amt",
			LBL_INSTRUC_CANCEL_AMOUNT: "Instr. Cancel Amt",
			LBL_INSTRUC_EXTRA_AMOUNT: "Instr. Extra Amt",

			LBL_BANK_ACCOUNT_NAME: "Bank Acc. Name",
			LBL_BANK_ACCOUNT_NO: "Bank Acc. No.",
			LBL_BANK_NAME: "Bank Name",
			LBL_BANK_PROVINCE: "Bank Province",
			LBL_BANK_DISTRICT: "Bank District",
			LBL_BANK_ADDRESS: "Bank Address",

			LBL_SO_RECEIVE: "S/O Receive",

			BTN_TITLE_SEARCH: "Supplier Bank Account",

			MSG_SUPLLIER_BANK_ACCOUNT_NOT_FOUND: "Supplier Bank Accounts not found",
			MSG_SO_YET_ACKNOWLEDGE: "Payment instruction for S/O: {so_no} yet to acknowledge"
		},
		CLOSE_ORDER_PAYMENT: {
			MODULE_NAME: "Close S/O Rcv Payment",
			BOX_TITLE: "Close S/O Rcv Payment - {so_no}",
			REVERT_BOX_TITLE: "Revert Closed S/O Rcv Payment - {so_no}",
			LBL_OUTSTANDING: "OutStanding",

			MSG_ORDER_WAS_CLOSED: "{so_no} was closed.",
			MSG_ORDER_SUCESSFUL_CLOSED: "{so_no} successfull closed",
			MSG_ORDER_SUCESSFUL_REVERT: "Closed S/O {so_no} successful revert"
		}
	},

	EPO_MANAGEMENT: {
		EPO_FORMAT: {
			EPO_FORMAT_PRINT_TITLE: "Print EPO"
		},
		EPO_LISTING: {
			LISTING_TITLE: "EPO Listing",
			CREATE_TITLE: "Create New EPO",
			DETAIL_TITLE: "EPO Detail",
			EDIT_TITLE: "Edit EPO Detail",

			MODULE_NAME: "EPO",

			EPO_MODULE_NAME: "EPO",
			CREATE_EPO_TITLE: "Create New EPO",

			LBL_EPO_DATE: "EPO Date",
			LBL_DELIVERY_ID: "Delivery ID",

			PH_ENTER_EPO_DATE_FROM: "Enter EPO Date From",
			PH_ENTER_EPO_DATE_TO: "Enter EPO Date To",

			COL_REQUEST_PLG: "PG",
			COL_EPO_NO: "EPO No",
			COL_MARKING: "Marking",
			COL_DELIVERY_ID: "Delivery Id",
			COL_COMPANY: "Company",
			COL_EPO_DATE: "Epo Date",
			COL_STATUS: "Status",
			COL_SUPPLIER_NAME: "Supplier Name",
			COL_GRAND_TOTAL: "Grand Total",
			COL_TOTAL_DEPOSIT: "Total Deposit",
			COL_EPO_TYPE: "EPO Type",
			COL_NOTICE_TYPE: "Notice Type",
			COL_NO_OF_RECEIVING: "No of rcv?",
			COL_TAX_REBATE: "Tax Rebate",

			BTN_VIEW: "View",
			BTN_DELETE: "Delete",

			TEXT_SAVE_AS_DRAFT: "Save As Draft",
			COL_SHIPMENT_TYPE_SHORT: "shpt type"
		},
		ORDER: {
			LISTING_TITLE: "EPO Listing",
			CREATE_ORDER_TITLE: "Create new Order",
			EPO_ORDER_TITLE: "EPO Order for {epo_no}",
			EPO_INFO_TITLE: "EPO Info",
			WAREHOUSE_DETAILS_TITLE: "Warehouse Details",
			FROM_WAREHOUSE_TITLE: "From Which Warehouse",
			WAY_TO_SHIP_TITLE: "How would you like to ship?",
			LOADING_PORT_TITLE: "Loading Port",
			FORWARDER_INFORMATION_TITLE: "Forwarder Details",
			DELIVERY_ADDRESS_TITLE: "Destination",
			DESTINATION_PORT_TITLE: "Destination Port",
			SUPPLIER_DETAILS_TITLE: "Supplier Info",
			PRODUCT_DETAILS_TITLE: "Courier / Product Details",
			SPECIAL_REQUEST_TITLE: "Special Request",
			CUSTOMER_NOTE_TITLE: "Customer Notes",
			LBL_EPO_NO: "EPO No",
			LBL_EPO_TYPE: "EPO Type",
			LBL_PO_EXISTS: "PO Exists?",
			LBL_CURRENCY: "Currency",
			LBL_COMPANY_NAME: "Company Name",
			LBL_PIC: "Person In Charge",
			LBL_EMAIL_ADDRESS: "Email Address",
			LBL_CONTACT_NUMBER: "Mobile Contact No.",
			LBL_BILL_ADDRESS: "Bill Address",
			LBL_OFFICE_CONTACT: "Office Contact No.",
			LBL_OFFICE_FAX_CONTACT: "Office Fax No.",
			LBL_CUSTOMER: "Customer",
			LBL_MARKING: "Customer Marking",
			LBL_SUPPLIER: "Supplier",
			LBL_SUPPLIER_ORDER_NO: "Supplier Order No",
			LBL_SUPPLIER_BANK_NAME: "Supplier Bank Name",
			LBL_SUPPLIER_BANK_ACCOUNT_NAME: "Supplier Bank Account Name",
			LBL_SUPPLIER_BANK_ACCOUNT_NO: "Supplier Bank Account No.",
			LBL_EXISTS_PO_NO: "Exists PO No.",
			LBL_DEPOSIT: "Deposit",
			LBL_ESTIMATE_DATE_DELIVERY: "Estimate Delivery Date",
			LBL_WAREHOUSE_TYPE: "Warehouse Type",
			LBL_WAREHOUSE: "Warehouse",
			LBL_PRODUCT_REMARK: "Remarks",
			LBL_EPO_SUBMIT_DATE: "EPO Date",
			LBL_DATE_FROM: "Date From",
			LBL_DATE_TO: "Date To",
			LBL_EPO_STATUS: "EPO Status",

			LBL_SUB_TOTAL: "Sub Total",
			LBL_TOTAL_DISCOUNT: "Total Discount",
			LBL_GRAND_TOTAL_AMOUNT: "Grand Total",

			EPO_TYPE_SELECTION_ORDER: "Order",
			EPO_TYPE_SELECTION_COURIER: "Courier",

			WAREHOUSE_SELECTION_OTHERS: "Others",

			PH_PIC: "Name",
			PH_SPECIAL_REQUEST: "Write a Message...",
			PH_LOADING_PORT: "Enter Loading Port",
			PH_DESTINATION_PORT: "Enter Destination Port",

			BTN_NEW_SUPPLIER: "New Supplier",

			COL_EPO_NO: "EPO No",
			COL_CREATED_AT: "Created On",
			COL_SHIPMENT_TYPE: "Shipment Type",
			COL_SHIPMENT_MODE: "Shipment Mode",
			COL_WAREHOUSE: "Warehouse",
			COL_SUPPLIER: "Supplier",
			COL_COUNTRY: "From/To Country",
			COL_STATUS: "Status",
			COL_EFFECTIVE_ON: "Effective On",
			COL_PRODUCT_NAME: "Commodity Desc",
			COL_REF_TYPE: "Container Type",
			COL_MARKING: "Customer Marking",

			PH_AUTO_DOC_NO: "[Auto]",

			SHIPPING: {
				LBL_TYPE: "Shipment Type",
				LBL_MODE: "Shipment Mode",
				LBL_MOVEMENT: "Movement Type",
				LBL_TERM: "Shipment Term"
			},

			SUPPLIER: {
				LBL_NAME: "Supplier/Forwarder Name",
				LBL_ADDRESS: "Address",
				LBL_POSTCODE: "Postal Code",
				LBL_CITY: "City",
				LBL_STATE: "State",
				LBL_CONTACT_NUMBER: "Supplier/Forwarder Contact Number",
				LBL_CONTACT_NUMBER_CALLING_CODE: "Supplier/Forwarder Calling Code"
			},

			DELIVERY: {
				LBL_ADDRESS_NAME: "Destination Address",
				LBL_ADDRESS: "Address",
				LBL_BUILDING_NAME: "Building Name",
				LBL_UPSTAIRS: "upstairs",
				LBL_COUNTRY: "Country",
				LBL_STATE: "State",
				LBL_CITY: "City",
				LBL_POSTCODE: "Postal Code",
				LBL_BRN: "Business Register Number"
			},

			PRODUCT: {
				COL_COURIER: "Courier",
				COL_ITEM_CODE: "Item Code",
				COL_PRODUCT_NAME: "Product Name",
				COL_BRAND: "Brand",
				COL_CATEGORY_GROUP: "Type",
				COL_CATEGORY_GROUP_TYPE: "Type Selection",
				COL_CATEGORY_GROUP_OTHERS: "Type Others",
				COL_QUANTITY: "Qty",
				COL_UOM: "Uom",
				COL_UNIT_PRICE: "Unit Price",
				COL_DISCOUNT_AMOUNT: "Discount Amount",
				COL_TOTAL_AMOUNT: "Total Amount",
				COL_REMARKS: "Remark",
				COL_PHOTO: "Photo",

				LBL_CONSIGNMENT_NO: "Consignment No",

				BTN_COPY: "Copy",
				BTN_ADD: "Add",
				BTN_DELETE: "Delete",
				BTN_UPLOAD: "Upload",
				BTN_CHANGE_CATEGORY_GROUP: "Modify Category Group",
				BTN_ADD_CONSIGNMENT_NO: "Add Consignment No",
				BTN_UPLOAD_PHOTO: "Upload Product Image",
				BTN_SUPPORT_DOCUMENT: "Upload Support Document",

				EXAMPLE_ENTER_PRODUCT_CATEGORY: "For Example Commodity Desc: Shirt, Shoes, Toy",
				EXAMPLE_ENTER_BRAND: "For Example Enter Multiple Brand: Addidas, Nike",

				PH_SELECT_CATEGORY_GROUP: "Please Select Category Group",
				PH_GOODS_AMOUNT_CURRENCY_SYMBOL: "Enter Currency Symbol",

				MSG_GOODS_AMOUNT_FROM_GREATER_TO: "Amount To must be greater than Amount From",
				MSG_GOODS_AMOUNT_FROM_REQUIRED: "Amount From Required"
			},

			CATEGORY_GROUP_TYPE: {
				MODAL_TITLE: "Category Type Details",

				LBL_CATEGORY_GROUP: "Goods Type",
				LBL_CATEGORY_GROUP_TYPE: "Selection of {category_group_name} product",
				LBL_OTHER_CATEGORY_GROUP_TYPE: "Discribe for {category_group_name} product",
				LBL_VALUABLE_OBJECTS: "Valuable objects",
				LBL_FRAGILE_ITEMS: "Fragile items",
				LBL_OTHER_SENSITIVE_ITEMS: "Other Sensitive Items",
				LBL_FAKE_BRANDS: "Fake Brands",

				PH_OTHER_CATEGORY_GROUP_TYPE: "Please input and discribe for {category_group_name} product",
				PH_FAKE_BRANDS: "Please input and discribe for Fake Brands"
			},
			UPLOAD: {
				PRODUCT_IMAGE: "Upload Product Image",
				SUPPORTED_DOCUMENT: "Upload Supported Document",
				LBL_UPLOAD_PHOTO: "Click to select the images.",
				LBL_UPLOAD_FILE: "Click to select the file.",
				SUPPORT_IMAGE_SIZE: "Supported size should be less than 1 MB!",
				MSG_SUPPORT_IMAGE_SIZE_FORMAT: "Supported size should be less than 1 MB and format .jpg, .jpeg, .png",
				SUPPORT_DOCUMENT_SIZE: "Supported size should be less than 10 MB!",
				MSG_SUPPORT_FILE_SIZE_FORMAT: "Supported size should be less than 10 MB! and format .xls, .xlsx, .pdf, .doc, .docs, .csv"
			},

			NEW_SUPPLIER: {
				MODAL_TITLE: "Create New Supplier"
			},

			BTN_SUBMIT: "Submit",
			BTN_RESET: "Reset",
			SUCCESS: "EPO Order has been generate and EPO No: {epo_no}.",
			FAILED: "Oopps ... ..., Sorry EPO Order Failed to Generate. Please try again.",
			MSG_FAILED_UPLOAD_IMGAE: "Sorry Product Image Failed to Upload",
			MSG_FAILED_UPLOAD_DOCUMENT: "Sorry Document Failed to Upload",
			MSG_NO_SUPPLIER: "Supplier not found. Please create a new supplier before create order",
			MSG_NO_ADDRESS: "Delivery Addresses not found. Please create a new delivery address before requesting for a quote",
			MSG_BILL_ADDRESS_NOT_FOUND: "Billing Address not found. Please set.",

			MSG_GRAND_TOTAL_AMOUNT_NEGATIVE: "Grand Total amount cannot be negative",
			MSG_PRODUCT_TOTAL_AMOUNT_NEGATIVE: "Product Total amount cannot be negative",
			MSG_ASCII: "only English letters, numbers, and standard symbols are allowed",
			MSG_PRODUCT_UNIT_PRICE_EMPTY: "Warning! your product unit price contain zero or empty value",
			MSG_SUCCESFUL_SAVE_AS_DRAFT: "Successful save as draft",
			MSG_BLOCK_EDIT: "You are not allow to edit this EPO Order.",
			MSG_DOCUMENT_TYPE: "No Document Type matched for current Marking. Please contact admin",
			MSG_DOCUMENT_NUMBER: "No Document Number matched for current Marking. Please contact admin",
			MSG_EPO_FORMAT_SETTINGS: "EPO Format Setting not matched. Please contact customer service",

			MSG_CONFIRMATION_SUBMIT: "Please ensure all details are correct before submitting.",
			MSG_PERSONAL_DATA_INCOMPLETE: "Personal Data Incomplete. Please complete first",
			RESET_FORM_CONFIRMATION: "All Information will be reset. Are you sure?",
			MSG_BILL_ADDRESS_INCOMPLETE: "Billing Address Incomplete",

			ERROR: {
				MSG_SUPPLIER_ADDRESS_EMPTY: "Supplier Address is empty",
				MSG_DELIVERY_ADDRESS_EMPTY: "Delivery Address is empty",
				MSG_BILLING_ADDRESS_EMPTY: "Billing Address is empty",
				CONTACT_PIC_REQUIRED: "CUstomer Name is empty",

				MSG_DOCUMENT_TYPE_EMPTY: "Missing Document Type Settings",
				MSG_DOCUMENT_NUMBER_EMPTY: "Missing Document Number Settings",
				MSG_EPO_SETTING_EMPTY: "Missing Epo Format Setting"
			}
		}
	},
	MASTER_DATA: {
		COUNTRIES: {
			COUNTRIES_NAME: "Country Name",
			CALLING_CODE: "Calling Code",
			LISTING_TITLE: "Country Listing",
			LBL_COUNTRIES_NAME: "Country Name",
			PH_ENTER_COUNTRIES_NAME: "Enter Country Name",
			PH_ENTER_COUNTRIES_CALLING_CODE: "Calling Code",
			DETAIL_TITLE: "Country Detail",
			MODULE_NAME: "Country",
			LBL_COUNTRIES_CALLING_CODE: "Calling Code"
		},
		STATES: {
			LISTING_TITLE: "State Listing",
			LBL_STATES_NAME: "State Name",
			LBL_COUNTRIES: "Country",
			LBL_STATES_CODE: "State Code",
			COL_NAME: "State Name",
			COL_COUNTRY: "Country",
			PH_ENTER_STATES_NAME: "Enter State Name",
			PH_ENTER_STATES_CODE: "Enter State Code",
			MODULE_NAME: "State",
			DETAIL_TITLE: "State Detail"
		},
		CITIES: {
			LISTING_TITLE: "City Listing",
			LBL_CITY_NAME: "City Name",
			LBL_COUNTRIES: "Country",
			LBL_STATES: "State",
			COL_NAME: "City Name",
			COL_COUNTRY: "Country",
			COL_STATE: "State",
			PH_ENTER_CITY_NAME: "Enter City Name",
			DETAIL_TITLE: "City Detail",
			MODULE_NAME: "City"
		},
		DISTRICT: {
			LISTING_TITLE: "District Listing",
			LBL_DISTRICT_NAME: "District Name",
			LBL_COUNTRIES: "Country",
			LBL_STATES: "State",
			LBL_CITY: "City",
			COL_NAME: "District Name",
			COL_COUNTRY: "Country",
			COL_STATE: "State",
			COL_CITY: "City",
			MODULE_NAME: "District",
			DETAIL_TITLE: "District Detail"
		},
		POSTCODES: {
			LISTING_TITLE: "Postcode Listing",
			LBL_POSTCODE: "Postcode",
			LBL_CITY: "City",
			LBL_COUNTRIES: "Country",
			LBL_STATES: "State",
			LBL_DISTRICT: "District",
			COL_POSTCODE: "Postcode",
			COL_COUNTRY: "Country",
			COL_STATE: "State",
			COL_CITY: "City",
			COL_DISTRICT: "District",
			PH_ENTER_POSTCODE_NAME: "Enter Postcode",
			PH_ENTER_POSTCODE: "Enter Postcode",
			DETAIL_TITLE: "Postcode Detail",
			MODULE_NAME: "Postcode"
		},
		PORT: {
			MODULE_NAME: "Port",
			LISTING_TITLE: "Port Listing",
			DETAIL_TITLE: "Port Detail",
			LBL_PORT_CODE: "Port Code",
			LBL_PORT_NAME: "Port Name",
			LBL_COUNTRIES: "Country",
			COL_PORT_CODE: "Port Code",
			COL_PORT_NAME: "Port Name",
			COL_COUNTRY_NAME: "Country"
		},
		CURRENCIES: {
			MODULE_NAME: "Currencies",
			LISTING_TITLE: "Currencies Listing",
			DETAIL_TITLE: "Currencies Detail",
			LBL_CURRENCIES_NAME: "Currency Name",
			LBL_CURRENCIES_CODE: "Currency Code",
			COL_CURRENCY_CODE: "Currency Code",
			COL_CURRENCY_NAME: "Currency Name",
			LBL_SYMBOL_LEFT: "Symbol Left",
			LBL_SYMBOL_RIGHT: "Symbol Right",
			LBL_DECIMAL_PLACE: "Exchange Rate Decimal Place",
			LBL_EXCHANGE_CURRENCY: "Exchange Currency Rate",
			COL_EXCHANGE_CURRENCY: "Exchange Currency",
			COL_CONVERSION_FACTOR: "Conversion Factor",
			COL_RATE: "Rate"
		},
		CURRENCIES_RATE: {
			BTN_CURRENCT_RATE_HISTORY: "Currency Rate History",
			HISTORY_TITLE: "Currency Rate History",
			LBL_DATE_FROM: "Date From",
			LBL_DATE_TO: "To",
			LABEL_CURRENCY: "Currency",
			LABEL_EXCHANGE_CURRENCY: "Exchange Currency",
			COL_DATE: "Date",
			COL_CURRENCY: "Currency",
			COL_EXCHANGE_CURRENCY: "Exchange Currency",
			COL_RATE: "Rate"
		},
		UOM: {
			MODULE_NAME: "UOM",
			DETAIL_TITLE: "Stock UOM Detail",
			LISTING_TITLE: "Stock UOM Listing",
			LBL_UOM_CODE: "Stock UOM Code",
			LBL_UOM_NAME: "Stock UOM Name",
			COL_UOM_CODE: "Stock UOM Code",
			COL_UOM_NAME: "Stock UOM Name",
			COL_PERCENTAGE: "Percentage",
			COL_USE_INVOICE: "Use for Invoice",
			COL_USE_RECEIVING: "Use for Receiving",
			COL_USE_EPO: "Use EPO/Receiving/Inv",
			LBL_UOM_QUOTATION_DESCRIPTION: "Quotation Description"
		},
		REFERENCE_TYPE: {
			MODULE_NAME: "Reference Type",
			DETAIL_TITLE: "Reference Type Detail",
			LISTING_TITLE: "Reference Type Listing",
			LBL_REF_TYPE_CODE: "Reference Type Code",
			LBL_REF_TYPE_NAME: "Reference Type Name",
			LBL_SHIPMENT_TYPE: "Shipment Type",
			COL_CODE: "Reference Type Code",
			COL_NAME: "Reference Type Name",
			COL_SHIPMENT_TYPE_NAME: "Shipment Type",
			LBL_QUOTATION: "Quotation",
			COL_FAVOURITE: "Favourite"
		},
		SHIPPER: {
			MODULE_NAME: "Shipper",
			DETAIL_TITLE: "Shipper Detail",
			LISTING_TITLE: "Shipper Listing",
			LBL_SHIPPER_NAME: "Shipper Name",
			LBL_SHIPPER_MOBILE_CONTACT_NO: "Mobile Contact No.",
			LBL_SHIPPER_EMAIL: "Email",
			LBL_SHIPPER_WAREHOUSE_ID: "Warehouse",
			LBL_SHIPPER_COUNTRY_ID: "Country",
			LBL_SHIPPER_STATE_ID: "State",
			LBL_SHIPPER_CITY_ID: "City",
			LBL_SHIPPER_OTHER_CITY_ID: "Other City",
			LBL_SHIPPER_POSTCODE_ID: "Postcode",
			LBL_SHIPPER_OTHER_POSTCODE_ID: "Other Postcode",
			LBL_SHIPPER_ADDRESS: "Address",
			LBL_SHIPPER_OFFICE_TEL_NO: "Tel No.",
			LBL_SHIPPER_OFFICE_FAX_NO: "Fax No.",
			LBL_SHIPPER_URL: "URL",
			LBL_SHIPPER_REMARK: "Remark",
			COL_SHIPPER_NAME: "Shipper Name",
			COL_SHIPPER_MOBILE_CONTACT_NO: "Mobile Contact No.",
			COL_SHIPPER_EMAIL: "Shipper Email"
		},
		SHIPPING_LINE: {
			MODULE_NAME: "Shipping Line",
			DETAIL_TITLE: "Shipping Line Detail",
			LISTING_TITLE: "Shipping Line Listing",
			LBL_SHIPPING_LINE_NAME: "Shipping Line Name",
			LBL_SHIPPING_LINE_MOBILE_CONTACT_NO: "Mobile Contact No.",
			LBL_SHIPPING_LINE_EMAIL: "Email",
			LBL_SHIPPING_LINE_COUNTRY_ID: "Country",
			LBL_SHIPPING_LINE_STATE_ID: "State",
			LBL_SHIPPING_LINE_CITY_ID: "City",
			LBL_SHIPPING_LINE_OTHER_CITY_ID: "Other City",
			LBL_SHIPPING_LINE_POSTCODE_ID: "Postcode",
			LBL_SHIPPING_LINE_OTHER_POSTCODE_ID: "Other Postcode",
			LBL_SHIPPING_LINE_ADDRESS: "Address",
			LBL_SHIPPING_LINE_OFFICE_TEL_NO: "Tel No.",
			LBL_SHIPPING_LINE_OFFICE_FAX_NO: "Fax No.",
			LBL_SHIPPING_LINE_URL: "URL",
			LBL_SHIPPING_LINE_REMARK: "Remark",
			COL_SHIPPING_LINE_NAME: "Shipping Line Name",
			COL_SHIPPING_LINE_MOBILE_CONTACT_NO: "Mobile Contact No.",
			COL_SHIPPING_LINE_EMAIL: "Shipper Email"
		},
		SHIPMENT_TYPE: {
			MODULE_NAME: "Shipment Type",
			DETAIL_TITLE: "Shipment Type Detail",
			LISTING_TITLE: "Shipment Type Listing",
			LBL_SHIPMENT_TYPE_NAME: "Shipment Type Name",
			COL_NAME: "Shipment Type Name",
			CHECKBOX_CATERGORY_TYPE_COST_TITLE: "Multiple Route & Shipment Mode",
			LBL_DEFAULT_SELECT: "Default (Customer Portal)",
			MODULE_QUOTATION: "Quotation",
			MODULE_EPO: "EPO",
			LBL_CATERGORY_TYPE_COST: "Category Type Cost",
			LBL_DEFAULT: "Default"
		},
		SENSITIVE_TYPE: {
			LISTING_TITLE: "Sensitive Type Listing",
			CREATE_TITLE: "Create New Sensitive Type",
			DETAIL_TITLE: "Sensitive Type Detail",
			EDIT_TITLE: "Edit Sensitive Type Detail",

			LBL_CATEGORY_GROUP: "Category Type",
			LBL_CATEGORY_GROUP_TYPE_CODE: "Sensitive Type Code",
			LBL_CATEGORY_GROUP_TYPE_NAME: "Sensitive Type Name",
			LBL_CATEGORY_GROUP_TYPE_DESCRIPTION: "Description",

			MODULE_NAME: "Sensitive Type",

			COL_CODE: "Sensitive Type Code",
			COL_NAME: "Sensitive Type Name",
			COL_CATEGORY_TYPE: "Category Type",
			COL_USE_FOR_EPO: "Use for EPO/Receiving",
			COL_PRINT_ON_QUOTE: "Print on Quotation"
		},
		SHIPMENT_TERMS: {
			LISTING_TITLE: "Shipment Terms Listing",
			CREATE_TITLE: "Create New Shipment Terms",
			DETAIL_TITLE: "Shipment Terms Detail",
			EDIT_TITLE: "Edit Shipment Terms",
			MODULE_NAME: "Shipment Terms",

			LBL_SHIPMENT_TERMS_CODE: "Shipment Terms Code",
			LBL_SHIPMENT_TERMS_NAME: "Shipment Terms Name",

			LBL_MOVEMENT_TYPE: "Movement Type",
			LBL_DESCRIPTION: "Description",

			COL_CODE: "Shipment Terms Code",
			COL_NAME: "Shipment Terms Name",
			COL_MOVEMENT_TYPE: "Movement Type"
		},
		CONSIGNEE: {
			MODULE_NAME: "Consignee",
			DETAIL_TITLE: "Consignee Detail",
			LISTING_TITLE: "Consignee Listing",
			LBL_NAME: "Consignee Name",
			LBL_CONSIGNEE_GROUP_NAME: "Consignee Group Name",
			LBL_CONSIGNEE_GROUP: "Consignee Group",
			LBL_EMAIL: "Email",
			LBL_ADDRESS: "Address",
			LBL_COUNTRY: "Country",
			LBL_STATE: "State",
			LBL_CITY: "City",
			LBL_POSTCODE: "Postcode",
			LBL_MOBILE_CONTACT_NO: "Mobile Contact No.",
			LBL_OFFICE_TEL_NO: "Office Tel No.",
			LBL_OFFICE_FAX_NO: "Office Fax No.",
			LBL_URL: "URL",
			LBL_REMARK: "Remark",
			COL_NAME: "Consignee Name",
			COL_GROUP_NAME: "Consignee Group Name",
			COL_MOBILE_CONTACT_NO: "Contact No.",
			COL_EMAIL: "Email",
			COL_ADDRESS: "Address"
		},
		CONSIGNEE_GROUP: {
			MODULE_NAME: "Consignee Group",
			DETAIL_TITLE: "Consignee Group Detail",
			LISTING_TITLE: "Consignee Group Listing",
			LBL_NAME: "Consignee Group Name",
			LBL_CODE: "Consignee Group Code",
			COL_NAME: "Consignee Name",
			COL_CODE: "Consignee Group Code",
			COL_REFERENCE_COUNT: "Reference Count",
			COL_EMAIL: "Email",
			COL_ADDRESS: "Address"
		},
		FORWARDER: {
			MODULE_NAME: "Forwarder",
			DETAIL_TITLE: "Forwarder Detail",
			LISTING_TITLE: "Forwarder Listing",
			LBL_NAME: "Forwarder Name",
			LBL_FORWARDER_GROUP_NAME: "Forwarder Group Name",
			LBL_FORWARDER_GROUP: "Forwarder Group",
			LBL_EMAIL: "Email",
			LBL_ADDRESS: "Address",
			LBL_COUNTRY: "Country",
			LBL_STATE: "State",
			LBL_CITY: "City",
			LBL_POSTCODE: "Postcode",
			LBL_MOBILE_CONTACT_NO: "Mobile Contact No.",
			LBL_OFFICE_TEL_NO: "Office Tel No.",
			LBL_OFFICE_FAX_NO: "Office Fax No.",
			LBL_URL: "URL",
			LBL_REMARK: "Remark",
			COL_NAME: "Forwarder Name",
			COL_GROUP_NAME: "Forwarder Group Name",
			COL_MOBILE_CONTACT_NO: "Contact No.",
			COL_EMAIL: "Email",
			COL_ADDRESS: "Address"
		},
		FORWARDER_GROUP: {
			MODULE_NAME: "Forwarder Group",
			DETAIL_TITLE: "Forwarder Group Detail",
			LISTING_TITLE: "Forwarder Group Listing",
			LBL_NAME: "Forwarder Group Name",
			LBL_CODE: "Forwarder Group Code",
			COL_NAME: "Forwarder Group Name",
			COL_CODE: "Forwarder Group Code",
			COL_REFERENCE_COUNT: "Reference Count"
		},
		NOTICE_TYPE: {
			LISTING_TITLE: "Notice Type Listing",
			CREATE_TITLE: "Create New Notice Type",
			DETAIL_TITLE: "Notice Type Detail",
			EDIT_TITLE: "Edit Notice Type Detail",

			LBL_NOTICE_TYPE_CODE: "Notice Type Code",
			LBL_NOTICE_TYPE_DESC: "Notice Type Desc",
			LBL_NOTICE_TYPE_GROUP: "Notice Type Group",
			LBL_NOTICE_TYPE_PAYMENT_TERMS_DESCRIPTION: "Quotation Payment Terms Description",
			LBL_NOTICE_TYPE_INSTRUCTION: "Notice Type Instruction",
			LBL_ORDER_RECEIPT: "Order Receipt",
			LBL_CASH_PAYMENT: "Cash Payment",
			LBL_DUE_DAYS: "Due Days",
			LBL_EPO_REMARK: "EPO Remark",
			LBL_WAREHOUSE: "Warehouse",
			LBL_EPO_IMPORTANT_NOTICE: "Important Notice",
			LBL_EPO_MARKING_REMARK: "Marking Remark",
			LBL_SUPPLIER_BANK: "Supplier Bank Required",
			LBL_EPO_SUPPLIER_BANK_REMARK: "Supplier Bank Remark",
			MODULE_NAME: "Notice Type",

			COL_NOTICE_TYPE_CODE: "Notice Type Code",
			COL_NOTICE_TYPE_DESC: "Notice Type Desc",
			COL_NOTICE_TYPE_GROUP: "Notice Type Group",
			COL_AGENT: "Agent",
			COL_NOTICE_TYPE_INSTRUCTION: "Notice Type Instruction",
			COL_ORDER_RECEIPT: "Order Receipt",
			COL_CASH_PAYMENT: "Cash Payment",
			COL_DUE_DAYS: "Due Days",

			BTN_ADD_NEW_EPO_REMARK: "Add New EPO Remark",
			BTN_ADD_REMOVE_EPO_REMARK: "Remove EPO Remark"
		},
		COMPANY: {
			CREATE_TITLE: "Create New Company",
			DETAIL_TITLE: "Company Detail",
			EDIT_TITLE: "Edit Company",
			MODULE_NAME: "Company",
			LISTING_TITLE: "Company Listing",

			LBL_COMPANY_NAME: "Company Name",
			LBL_COMPANY_CODE: "Company Code",
			LBL_COMPANY_REGISTER_NUMBER: "Company Business Register Number",
			LBL_COMPANY_EMAIL: "Email",
			LBL_COMPANY_GROUP_NAME: "Group Name",
			LBL_TAX_CODE: "Tax Code",

			LBL_COMPANY_GROUP: "Company Group",
			LBL_COMPANY_GROUP_CODE: "Company Group Code",

			LBL_CONTACT_NUMBER: "Contact Number",
			LBL_FAX_NUMBER: "Fax Number",

			LBL_BUSINESS_NATURE: "Business Nature",
			LBL_WEBSITE: "Website",
			LBL_COMPANY_ADDRESS: "Company Address",
			LBL_COUNTRIES: "Country",
			LBL_STATES: "State",
			LBL_CITY: "City",
			LBL_POSTCODE: "Postcode",
			LBL_COMPANY_LOGO: "Company Logo",
			LBL_TAX_TYPE: "Tax Type",
			LBL_TAX_REGISTERDATE: "Register Date",
			LBL_TAX_NUMBER: "Register Number",
			LBL_TAX_REGISTER_TYPE: "Tax Register Type",
			LBL_TAX_EFFECTIVEDATE: "Effective Date",
			LBL_TAX_VALIDATIONDATE: "Verify Date",
			LBL_TAX_PIC: "Person Incharge",
			LBL_BANK: "Bank(s)",

			COL_COMPANY_GROUP_CODE: "Code",
			COL_GL_SALES_ACCOUNT: "GL Sales Account",
			NO_TAX: "No Tax",

			MSG_FAILED_TOUPLOAD_IMAGE: "Failed To Upload Company Logo.",

			COL_COMPANY_CODE: "Company Code",
			COL_COMPANY_NAME: "Company Name",
			COL_AGENT: "Agent",

			BANK_TABLE: {
				COL_SHOW: "Show",
				COL_ACCOUNT_NAME: "Account Name",
				COL_ACCOUNT_NO: "Account No",
				COL_BANK_NAME: "Bank Name"
			},

			MSG_IMG_SUPPORTED: "*Support JPG,JPEG,PNG,GIF file, file size not more that 500kb.",
			MSG_IMAGE_SIZE: "*image size(W x L) 590x208",

			MSG_IMAGE_ERROR_TITLE: "File size is too huge",
			MSG_IMAGE_ERROR_SIZE: "The size of file should be less than 500 KB"
		},
		WAREHOUSE: {
			LISTING_TITLE: "Warehouse List",
			CREATE_TITLE: "Create New Warehouse",
			DETAIL_TITLE: "Warehouse Detail",
			EDIT_TITLE: "Edit Warehouse",

			MODULE_NAME: "Warehouse",

			LBL_WAREHOUSE_CODE: "WH Code",
			LBL_WAREHOUSE_NAME: "WH Name",

			COL_WAREHOUSE_CODE: "Warehouse Code",
			COL_WAREHOUSE_NAME: "Warehouse Name",
			COL_STICKER_FEE: "Sticker Fee",

			LBL_CONTACT: "Contact Person",
			LBL_COMPANY: "Company",
			LBL_WAREHOUSE_ADDRESS: "Address",
			LBL_SUPPORTED_SHIPMENT_TYPE: "Supported Shipment Type",
			LBL_QUOTATION_DESC: "Quotation Desc",
			LBL_MOVEMENT_TYPE: "Movement Type",
			LBL_API_URL: "GBIZS WMS API URL",
			LBL_GOODS_RECEIPT_PAYABLE_NOTE_PIC: "Goods Receipt/Payable Note Contact Person",
			LBL_QUOTE_AREA: "Replace {area} with State & City",
			LBL_WAREHOUSE_NAME_PRINT_IN_EPO: "Warehouse Name Print on EPO",
			LBL_FORWARDER: "Forwarder",
			LBL_FORWARDER_COUNTRY_ID: "Forwarder Country ID",
			LBL_FORWARDER_STATE_ID: "Forwarder State ID",
			YES_STATUS_VAL: "Yes",

			COL_PIC: "Person In Charge",
			COL_CONTACT_NUMBER: "Contact Number",
			COL_WECHAT_ID: "WeChat ID",
			COL_EMAIL: "Email",
			COL_IS_DEFAULT: "Default",
			COL_IS_SHOW: "Show",
			COL_REMARK: "Remark",
			COL_CONTACT_CALLING_CODE: "Contact Number Calling Code",
			LBL_EPO_SPECIAL_REMARK: "EPO Special Remark",
			LBL_EPO_FOOTER_REMARK: "EPO Footer Remark",
			LBL_EPO_WAREHOUSE_CONTACT_REMARK: "EPO Warehouse Contact Remark",
			LBL_YES: "Yes",
			LBL_STATE: "state"
		},
		WAREHOUSE_LOCATION: {
			MODULE_NAME: "Warehouse Location",
			LISTING_TITLE: "Warehouse Location Listing",
			LBL_WAREHOUSE_LOCATION_CODE: "Location Code",
			LBL_WAREHOUSE_LOCATION_NAME: "Location Name",
			LBL_WAREHOUSE: "Warehouse",
			CREATE_TITLE: "Create New Warehouse Location",
			DETAIL_TITLE: "Warehouse Location Detail",
			EDIT_TITLE: "Edit Warehouse Location",

			COL_LOCATION_CODE: "Location Code",
			COL_LOCATION_NAME: "Location Name",
			COL_WAREHOUSE_NAME: "Warehouse Name"
		},
		MAINTAIN_COURIER_SERVICE: {
			MODULE_NAME: "Maintain Courier Service",
			LISTING_TITLE: "Maintain Courier Service Listing",
			CREATE_TITLE: "Create New Maintain Courier Service",
			DETAIL_TITLE: "Maintain Courier Service Detail",
			EDIT_TITLE: "Edit Maintain Courier Service",

			COURIER_SERVICE_ID: "Courier Service ID",
			COURIER_SERVICE_DESCRIPTION: "Courier Service Description",
			REMARK: "Remark"
		},
		MAINTAIN_AGENT: {
			MODULE_NAME: "Maintain Agent",
			LISTING_TITLE: "Maintain Agent Listing",
			CREATE_TITLE: "Create New Maintain Agent",
			DETAIL_TITLE: "Maintain Agent Detail",
			EDIT_TITLE: "Edit Maintain Agent",

			ADD: "Add",
			AGENT_ID: "Agent Id",
			AGENT_NAME: "Agent Name",
			URL: "Tracking url",
			COURIER_ID: "Courier ID",
			COUNTRY_ID: "Country",
			ROUTING: "Routing",
			SB_ROUTING: "SB Routing",
			SRW_ROUTING: "SRW Routing",
			NORMAL_GOODS_TEXT: "Normal Goods Text",
			SENSITIVE_GOODS: "Sensitive Goods"
		},
		SUPPLIER: {
			MODULE_NAME: "Supplier",
			LISTING_TITLE: "Supplier Listing",
			CREATE_TITLE: "Create New Supplier",
			DETAIL_TITLE: "Supplier Detail",
			EDIT_TITLE: "Edit Supplier Detail",
			CODE: "Supplier Code",
			NAME: "Supplier Name",

			CONTACT_NO: "Contact No.",
			CONTACT_NAME: "Contact Name",
			OFFICE_NO: "Office No.",
			OFFICE_NAME: "Office PIC Name",

			REMARK: "Remark",

			BANKS: {
				ADD: "Add New Bank"
			},
			OTHER_PHONE_NO: "Other Phone No.",
			MSG: {
				SUPPLIER_EXISTS: "Supplier with same name and warehouse exists."
			}
		},
		DOC_TYPE: {
			LISTING_TITLE: "Doc Type Listing",
			CREATE_TITLE: "Create New Doc Type",
			DETAIL_TITLE: "Doc Type Detail",
			EDIT_TITLE: "Edit Doc Type Detail",

			LBL_DOC_TYPE_CODE: "Doc Type Code",
			LBL_DOC_TYPE_DESC: "Doc Type Desc",
			LBL__DOC_TYPE_NOTICE_TYPE: "Notice Type",
			LBL_POSTING_SIDE: "Posting Site",
			LBL_USE_SAME_ID: "Use Same ID",
			STATUS: "Status",

			MODULE_NAME: "Doc Type",

			COL_DOC_TYPE_CODE: "Doc Type Code",
			COL_DOC_TYPE_DESC: "Doc Type Desc",
			COL_POSTING_SIDE: "Posting Side",
			COL_USE_SAME_ID: "Use Same ID",

			SELECTION: {
				NO_POSTING: "No Posting",
				CREDIT: "Credit",
				DEBIT: "Debit"
			}
		},
		DOC_NUM: {
			LISTING_TITLE: "Doc Numbering Listing",
			CREATE_TITLE: "Create New Doc Numbering",
			DETAIL_TITLE: "Doc Numbering Detail",
			EDIT_TITLE: "Edit Doc Numbering Detail",

			LBL_NUM_DESC: "Doc Numbering Desc",
			LBL_DOC_TYPE: "Doc Type",
			LBL_WAREHOUSE: "Warehouse",
			LBL_NUM_BY_COMPANY_SUBGROUP: "By Company Sub Group?",
			LBL_COMPANY_SUBGROUP: "Company Sub Group",
			LBL_NUM_PREFIX: "Numbering Prefix",
			LBL_NUM_PREFIX_WITH_WAREHOUSE_COUNTRY: "Prefix with Warehouse Country?",
			LBL_NUM_POSTFIX: "Numbering Postfix",
			LBL_NUM_RESET: "Reset",
			LBL_NOTICE_TYPE: "Notice Type",
			LBL_NUM_DIGIT_COUNT: "Digit Count",
			LBL_NUM_LAST_NUM_INT: "Last Numbering (In Digit)",
			LBL_NUM_LAST_NUM_FORMAT: "Last Numbering (In Full)",
			LBL_AGENT: "Agent",

			MODULE_NAME: "Doc Numbering",

			COL_NUM_DESC: "Doc Numbering Desc",
			COL_DOC_TYPE: "Doc Type",
			COL_WAREHOUSE: "Warehouse",
			COL_NUM_BY_COMPANY_SUBGROUP: "By Company Sub Group ?",
			COL_COMPANY_SUBGROUP: "Company Sub Group",
			COL_NUM_PREFIX: "Numbering Prefix",
			COL_NUM_POSTFIX: "Numbering Postfix",
			COL_NUM_RESET: "Reset",
			COL_NUM_DIGIT_COUNT: "Digit Count",
			COL_NUM_LAST_NUM_INT: "Last Numbering (In Number)",
			COL_NUM_LAST_NUM_FORMAT: "Last Numbering (In Full)",

			SELECTION: {
				NO_RESET: "None",
				BY_YEAR: "By Year",
				BY_MONTH: "By Month"
			},

			DOC_NUM_FORMAT: "{prefix}{date}{number}{postfix}"
		},
		NOTICE_TYPE_GROUP: {
			LISTING_TITLE: "Notice Type Group Listing",
			CREATE_TITLE: "Create Notice Type Group",
			DETAIL_TITLE: "Notice Type Group Detail",
			EDIT_TITLE: "Edit Notice Type Group Detail",
			MODULE_NAME: "Notice Type Group",

			LBL_NOTICE_TYPE_GROUP_CODE: "Notice Type Group Code",
			LBL_NOTICE_TYPE_GROUP_DESC: "Notice Type Group Desc",
			LBL__DOC_TYPE_NOTICE_TYPE: "Notice Type",
			LBL_POSTING_SIDE: "Posting Site",
			LBL_USE_SAME_ID: "Use Same ID",

			COL_NOTICE_TYPE_GROUP_CODE: "Notice Type Group Code",
			COL_NOTICE_TYPE_GROUP_DESC: "Notice Type Group Desc",
			COL_POSTING_SIDE: "Posting Side",
			COL_USE_SAME_ID: "Use Same ID",
			COL_AGENT: "Agent",

			SELECTION: {
				NO_POSTING: "No Posting",
				CREDIT: "Credit",
				DEBIT: "Debit"
			}
		},
		CONTAINER: {
			COURIER_SERVICE: {
				MODULE_NAME: "Courier Company",
				LISTING_TITLE: "Courier Company Listing",
				CREATE_TITLE: "Create New Courier Company",
				DETAIL_TITLE: "Courier Company Detail",
				EDIT_TITLE: "Edit Courier Company",
				CODE: "Code",
				NAME: "Name",
				WAREHOUSE: "Warehouse"
			},
			DELIVERY_AGENT: {
				MODULE_NAME: "Courier Agent",
				LISTING_TITLE: "Courier Agent Listing",
				CREATE_TITLE: "Create New Courier Agent",
				DETAIL_TITLE: "Courier Agent Detail",
				EDIT_TITLE: "Edit Courier Agent",
				CODE: "Code",
				NAME: "Name",
				SHIPMENT: "Shipment Type",
				WAREHOUSE: "Warehouse",
				LABEL: "Label",
				IS_DEFAULT: "Is Default?"
			},
			DELIVERY_AGENT_LINKAGE: "Courier Agent Courier Company Linkage"
		}
	},
	INQUIRY: {
		REOPEN_SO_TITLE: "Reopen S/O",
		REOPEN_SO_HISTORY: "Reopen S/O Log (S/O No: {so_no})",
		REOPEN_LOADING: "Reopen Loading",
		PAYMENT_HISTORY_TITLE: "Payment History"
	},
	PAYMENT_HISTORY: {
		TITLE: "Payment History",
		PN_NO: "PN No",
		SUPPLIER_NAME: "Supplier Name",
		PAYMENT_DATE: "Payment Date",
		SUPPLIER_CODE: "Supplier Code",
		DEPOSIT_AMOUNT: "Deposit Amount",
		WH_CHARGES: "Wh Charges",
		DEPOSIT_AMOUNT: "Deposit Amount",
		SO_CUS_DEPOSIT: "So Cus Deposit",
		DISCOUNT_AMOUNT: "Discount Amount",
		MY_PAID: "My Paid",
		CASH_PAYMENT: "Cash Payment",
		SUP_WH_DISC: "Sup Wh Disc",
		FCP_AMOUNT: "FCP Amount",
		BALANCE_AMOUNT: "Balance Amount",
		PAID_AMOUNT: "Paid Amount",
		CLOSED_AMOUNT: "Closed Amount",
		CLOSE_REMARK: "Close Remark",
		IS_FULLY_CANCELLED: "Cancel Full So Amt"
	},
	SALESMAN_MANAGEMENT: {
		MAIN_SALESMAN: {
			CREATE_TITLE: "Create New Main Salesman",
			MODULE_NAME: "Main Salesman",
			EDIT_TITLE: "Edit Main Salesman",
			DETAIL_TITLE: "Main Salesman Detail",
			LISTING_TITLE: "Main Salesman Listing",

			LBL_MSM_CODE: "Main Salesman Code",
			LBL_MSM_NAME: "Main Salesman Name",
			LBL_COMPANY: "Company",

			LBL_EMAIL: "Email",
			LBL_JOINDATE: "Join Date",

			LBL_CONTACT_NUMBER: "Office Number",
			LBL_MOBILE_NUMBER: "Mobile Number",
			LBL_WECHATID: "Wechat ID",

			LBL_SALESMAN_COSTING_GROUP: "Salesman Costing Group",

			COL_GROUP_CODE: "Group Code",
			COL_GROUP_NAME: "Group Name",
			LBL_LOGIN_NAME: "Username",
			LBL_PASSWORD: "Password",
			LBL_CONFIRM_PASSWORD: "Confirm Password",
			COL_MSM_CODE: "Main Salesman Code",
			COL_MSM_NAME: "Main Salesman Name",
			BTN_GROUP_LIST: "Group List"
		},
		SALESMAN: {
			LISTING_TITLE: "Salesman Listing",
			DETAIL_TITLE: "Salesman Detail",
			EDIT_TITLE: "Edit Salesman Detail",
			CREATE_TITLE: "Create New Salesman",
			MODULE_NAME: "Salesman",

			LBL_SM_CODE: "Salesman Code",
			LBL_SM_NAME: "Salesman Name",

			COL_SM_CODE: "Salesman Code",
			COL_SM_NAME: "Salesman Name",
			COL_MSM_NAME: "Main Salesman Name",

			LBL_LOGIN_NAME: "Username",
			LBL_PASSWORD: "Password",
			LBL_CONFIRM_PASSWORD: "Confirm Password",
			LBL_EMAIL: "Email",
			LBL_JOINDATE: "Join Date",

			LBL_CONTACT_NO_CALLING_CODE: "Office Number Calling Code",
			LBL_CONTACT_NUMBER: "Office Number",
			LBL_MOBILE_NUMBER: "Mobile Number",
			LBL_MOBILE_NO_CALLING_CODE: "Mobile Number Calling Code",
			LBL_WECHATID: "Wechat ID",
			LBL_MAINSALESMAN: "Main Salesman",
			LBL_SALESMAN_COST: "Salesman Cost",

			COL_MAIN_SALESMAN: "Main Salesman",
			COL_SM_COST_GROUP: "Salesman Group Cost",
			COL_SM_MIN_COST_GROUP: "Salesman Group Min Cost"
		}
	},
	SETTINGS: {
		GENERAL: {
			TITLE: "General Settings",

			LBL_EMAIL_FROM: "Sender Email",
			LBL_WAREHOUSE: "Warehouse",
			MODULE_NAME: "General Settings",
			LBL_LOGIN_TITLE: "Login Title",
			LBL_SIDE_TITLE_IMAGE: "Side Title Image",
			LBL_META_TITLE: "Meta Title",
			TAB_TITLE: {
				GENERAL: "General"
			}
		},
		// Payable Setting
		PAYABLE_SETTING: {
			LISTING_TITLE: "Payable Setting Listing",
			CREATE_TITLE: "Create New Payable Setting",
			EDIT_TITLE: "Edit Payable Setting",
			DETAIL_TITLE: "Payable Setting Detail",
			MODULE_NAME: "Payable Setting",
			LBL_CODE: "Payable Setting Code",
			LBL_NAME: "Payable Setting Name",
			LBL_PAYABLE_FORMAT_TYPE: "Payable Format Type",
			LBL_NOTICE_TYPE: "Notice Type",
			LBL_WAREHOUSE: "Warehouse",
			LBL_PAYABLE_FORMAT_TITLE: "Payable Format Title",
			LBL_MARKING_REMARK: "Marking Remark",
			LBL_IMPORTANT_NOTICE: "Important Notice",
			LBL_HEADER_REMARK: "Header Remark",
			LBL_FOOTER_REMARK: "Footer Remark",
			LBL_DESCRIPTION: "Description",
			LBL_LOCALE: "Locale",
			LBL_SUPPORT_AT: "Support At",
			LBL_SORT_ORDER: "Sort Order",
			LBL_IMAGE: "Image",
			LBL_SHIPMENT_FORMAT_TITLE: "Shipment Format Title",
			LBL_SHIPMENT_MODE: "Shipment Mode",
			LBL_DELIVERY_ZONE: "Delivery Zone",

			COL_NAME: "Payable Setting Name",
			COL_NOTICE_TYPE: "Notice Type",
			COL_WAREHOUSE: "Warehouse",

			COL_PAYABLE_FORMAT_TITLE_NOTICE_TYPE: "Notice Type",
			COL_PAYABLE_FORMAT_TITLE_WAREHOUSE: "Warehouse",
			COL_PAYABLE_FORMAT_TITLE: "Title",
			COL_SHIPMENT_MODE: "Shipment Mode",
			COL_DELIVERY_ZONE: "Delivery Zone",

			SUPPORT_AT_SELECTION: {
				ALL: "Admin Portal & Customer Portal",
				ADMIN: "Admin Portal Only",
				CUSTOMER: "Customer Portal Only"
			}
		},
		// End Payable Setting
		/**Start Warehouse Settings */
		WAREHOUSE_SETTINGS: {
			LISTING_TITLE: "Warehouse Settings",
			TITLE: "Warehouse Settings",

			COL_WAREHOUSE_CODE: "Warehouse Code",
			COL_STICKER_FEE: "Sticker Fee",
			COL_AGENT_ID: "Agent"
		}
		/**End Warehouse Settings */
	},
	CUSTOMER_MANAGEMENT: {
		CUSTOMER: {
			LISTING_TITLE: "Customer Listing",
			CREATE_TITLE: "Create New Customer",
			DETAIL_TITLE: "Customer Detail",
			EDIT_TITLE: "Edit Customer Detail",

			CREATE_CUSTOMER_MARKING_TITLE: "Create New Customer Marking",

			TITLE_CUSTOMER_LOGIN_INFO: "Login Information",
			TITLE_CUSTOMER_BASIC_INFO: "Basic Information",
			TITLE_CUSTOMER_BILLING_ADDRESS_INFO: "Billing Address Information",
			TITLE_CUSTOMER_COMPANY_INFO: "Company Information",

			LBL_CUSTOMER_SELECT_TYPE: "N",

			LBL_CUSTOMER_LOGIN_INFO_TYPE: "Customer Login",
			LBL_CUSTOMER_LOGIN_EXITING_INFO: "Customer Login Selection",

			LBL_CUSTOMER_MARKING: "Marking",
			LBL_CUSTOMER_DEBTOR_ID: "Debtor Id",
			LBL_CUSTOMER_PARTNER_NAME: "Partner Name",
			LBL_CUSTOMER_NAME: "Partner Name",
			LBL_CUSTOMER_CUSTOMER_TYPE: "Customer Type",
			LBL_CUSTOMER_NRIC_OR_BRN: "NRIC / BRN",
			LBL_CUSTOMER_EMAIL: "Email",
			LBL_CUSTOMER_NICKNAME: "Login Nickname",
			LBL_CUSTOMER_MOBILE_NO: "Mobile No",
			LBL_CUSTOMER_PASSWORD: "Password",
			LBL_CUSTOMER_CONFIRM_PASSWORD: "Confirm Password",
			LBL_CUSTOMER_CONTROL_ACCOUNT: "Control Account",
			LBL_CUSTOMER_MAINSALESMAN: "Main Salesman",
			LBL_CUSTOMER_SALESMAN: "Salesman",
			LBL_CUSTOMER_COMPANY: "Company",
			LBL_CUSTOMER_COMPANY_GROUP: "Company Group",
			LBL_CUSTOMER_CURRENCY: "Currency",
			LBL_CUSTOMER_CREDIT_TERM: "Credit Term",
			LBL_CUSTOMER_NOTICE_TYPE: "Notice Type",
			LBL_CUSTOMER_CREDIT_TERM_DAYS: "Term Days{terms_name}",
			LBL_CUSTOMER_IS_DEFAULT: "Is Default",
			LBL_CUSTOMER_IS_VERIFIED: "Is Verified",

			LBL_CUSTOMER_GST_NO: "GST No",
			LBL_CUSTOMER_GST_VERIFY_DATE: "GST Verify Date",
			LBL_CUSTOMER_GST_USE_NONE_DEFAULT_CODE: "Use None Default GST Code",
			CHECKBOX_USE_NONE_DEFAULT: "Use None Default",
			LBL_CUSTOMER_DEFAULT_INVOICE_FORMAT: "Default Invoice Format",
			LBL_SPECIAL_RATE: "Special Rate #",
			LBL_SPECIAL_RATE_REMARK: "Special Rate",
			LBL_SM_FINANCE_RATE: "Salesman Finance Rate",
			LBL_FINANCE_RATE: "Finance Rate",
			LBL_USE_CUSTOMER_DO_HEADER: "Use Customer Do Header",

			LBL_CUSTOMER_USERNAME: "Email",
			LBL_CUSTOMER_RE_PASSWORD: "Confirm Password",
			LBL_CUSTOMER_OVERDUE_LIMIT: "Overdue Limit",
			LBL_CUSTOMER_BILLING_ADDRESS: "Billing Address",
			LBL_CUSTOMER_CONTACT_PERSON_NAME: "Contact Person Name",
			LBL_CUSTOMER_CONTACT_EMAIL: "Contact Email",
			LBL_CUSTOMER_CONTACT_MOBILE_NO: "Contact Mobile No",
			LBL_CUSTOMER_CONTACT_OFFICE_NO: "Contact Office No",
			LBL_CUSTOMER_CONTACT_FAX_NO: "Contact Fax No",
			LBL_CUSTOMER_COMPANY_NAME: "Company Name",
			LBL_CUSTOMER_COMPANY_WEBSITE: "Company Website",
			LBL_CUSTOMER_TAX_TYPE: "Tax Type",
			LBL_CUSTOMER_TAX: "Tax",
			LBL_CUSTOMER_CTOS_NO: "CTOS Account",
			LBL_CUSTOMER_CTOS_DATE: "CTOS Date",

			LBL_CUSTOMER_BILLING_ADD: "Billing Address",
			LBL_CUSTOMER_BILLING_ADD_DESCRIPTION: "Address Description",
			LBL_CUSTOMER_BILLING_ADD_REMARK: "Attention",
			LBL_CUSTOMER_BILLING_ADD_BUILDING_NAME: "Building Name",
			LBL_CUSTOMER_BILLING_ADD_ADDRESS: "Billing Address",
			LBL_CUSTOMER_BILLING_ADD_COUNTRY: "Country",
			LBL_CUSTOMER_BILLING_ADD_STATE: "State",
			LBL_CUSTOMER_BILLING_ADD_CITY: "City",
			LBL_CUSTOMER_BILLING_ADD_OTHER_CITY: "Other City",
			LBL_CUSTOMER_BILLING_ADD_POSTCODE: "Postcode",
			LBL_CUSTOMER_BILLING_ADD_OTHER_POSTCODE: "Other Postcode",
			LBL_CUSTOMER_BILLING_ADD_MOBILE_CONTACT_PIC_NAME: "Mobile Contact PIC Name",
			LBL_CUSTOMER_BILLING_ADD_MOBILE_CONTACT_NO: "Mobile Contact No",
			LBL_CUSTOMER_BILLING_ADD_MOBILE_ALT_CONTACT_PIC_NAME: "Mobile Alt Contact PIC Name",
			LBL_CUSTOMER_BILLING_ADD_MOBILE_ALT_CONTACT_NO: "Mobile Alt Contact No",
			LBL_CUSTOMER_BILLING_ADD_OFFICE_TEL_PIC_NAME: "Office Tel PIC Name",
			LBL_CUSTOMER_BILLING_ADD_OFFICE_TEL_NO: "Office Tel No",
			LBL_CUSTOMER_BILLING_ADD_WEBSITE: "Website",
			LBL_CUSTOMER_BILLING_ADD_EMAIL: "Email",
			LBL_CUSTOMER_BILLING_ADD_ALT_EMAIL: "Alt Email",

			LBL_CUSTOMER_MARKING_BILLING_ADD: "Billing Address",
			LBL_CUSTOMER_MARKING_BILLING_ADD_DESCRIPTION: "Address Description",
			LBL_CUSTOMER_MARKING_BILLING_ADD_REMARK: "Attention",
			LBL_CUSTOMER_MARKING_BILLING_ADD_BUILDING_NAME: "Building Name",
			LBL_CUSTOMER_MARKING_BILLING_ADD_ADDRESS: "Billing Address",
			LBL_CUSTOMER_MARKING_BILLING_ADD_COUNTRY: "Country",
			LBL_CUSTOMER_MARKING_BILLING_ADD_STATE: "State",
			LBL_CUSTOMER_MARKING_BILLING_ADD_CITY: "City",
			LBL_CUSTOMER_MARKING_BILLING_ADD_OTHER_CITY: "Other City",
			LBL_CUSTOMER_MARKING_BILLING_ADD_POSTCODE: "Postcode",
			LBL_CUSTOMER_MARKING_BILLING_ADD_OTHER_POSTCODE: "Other Postcode",
			LBL_CUSTOMER_MARKING_BILLING_ADD_MOBILE_CONTACT_PIC_NAME: "Mobile Contact PIC Name",
			LBL_CUSTOMER_MARKING_BILLING_ADD_MOBILE_CONTACT_NO: "Mobile Contact No",
			LBL_CUSTOMER_MARKING_BILLING_ADD_MOBILE_ALT_CONTACT_PIC_NAME: "Mobile Alt Contact PIC Name",
			LBL_CUSTOMER_MARKING_BILLING_ADD_MOBILE_ALT_CONTACT_NO: "Mobile Alt Contact No",
			LBL_CUSTOMER_MARKING_BILLING_ADD_OFFICE_TEL_PIC_NAME: "Office Tel PIC Name",
			LBL_CUSTOMER_MARKING_BILLING_ADD_OFFICE_TEL_NO: "Office Tel No",
			LBL_CUSTOMER_MARKING_BILLING_ADD_WEBSITE: "Website",
			LBL_CUSTOMER_MARKING_BILLING_ADD_EMAIL: "Email",
			LBL_CUSTOMER_MARKING_BILLING_ADD_ALT_EMAIL: "Alt Email",
			LBL_CUSTOMER_MARKING_USE_BILLING_MARKING: "Use Marking Billing?",

			LBL_CUSTOMER_PREFERENCE_TERRITORY: "Territory",
			LBL_CUSTOMER_PREFERENCE_INDUSTRIES: "Industries",
			LBL_CUSTOMER_PREFERENCE_PARTNER_TYPE: "Partner Type",
			LBL_CUSTOMER_PREFERENCE_GL_SALES_ACCOUNT: "GL Sales Account",
			LBL_CUSTOMER_PREFERENCE_STATEMENT_TYPE: "Statement Type",

			LBL_CUSTOMER_CREDIT_CONTROL_CREDIT_LIMIT: "Credit Limit",
			LBL_CUSTOMER_CREDIT_CONTROL_CREDIT_LIMIT_OVER_ACTION_TYPE: "Action On Credit Limit was over",
			LBL_CUSTOMER_CREDIT_CONTROL_COMBINE_LIMIT: "Combine Limit",
			LBL_CUSTOMER_CREDIT_CONTROL_COMBINE_LIMIT_OVER_ACTION_TYPE: "Action On Combine Limit was over",

			LBL_CUSTOMER_CREDIT_CONTROL_OVERDUE_DAYS: "Overdue Days",
			LBL_CUSTOMER_CREDIT_CONTROL_OVERDUE_LIMIT: "Overdue Limit",
			LBL_CUSTOMER_CREDIT_CONTROL_OVERDUE_LIMIT_OVER_ACTION_TYPE: "Action On Overdue Limit was over",
			LBL_CUSTOMER_CREDIT_CONTROL_TOTAL_OVERDUE_LIMIT: "Total Overdue Limit",
			LBL_CUSTOMER_CREDIT_CONTROL_TOTAL_OVERDUE_LIMIT_OVER_ACTION_TYPE: "Action On Total Overdue Limit was over",
			LBL_CUSTOMER_CREDIT_CONTROL_TOTAL_OVERDUE_DAYS: "Total Overdue Days",

			LBL_CUSTOMER_NOTE_INVOICE_NOTE: "Invoice Note",
			LBL_CUSTOMER_NOTE_AR_NOTE: "AR Note",

			LBL_CUSTOMER_TRANSACTION_DESC_INVOICE_DESC: "Invoice Description",
			LBL_CUSTOMER_TRANSACTION_DESC_DN_DESC: "DN Description",
			LBL_CUSTOMER_TRANSACTION_DESC_CN_DESC: "CN Description",
			LBL_CUSTOMER_TRANSACTION_DESC_PAYMENT_DESC: "Transaction Description",

			LBL_CUSTOMER_INTEREST_PENALTY_PA_TITLE: "PA (Purchase)",
			LBL_CUSTOMER_INTEREST_PENALTY_PA_MODE: "PA Penalty Mode",
			LBL_CUSTOMER_INTEREST_PENALTY_PA_RATE: "PA Penalty Rate",
			LBL_CUSTOMER_INTEREST_PENALTY_PA_TERMS_DAY: "PA Penalty Terms Day",
			LBL_CUSTOMER_INTEREST_PENALTY_PA_ALLOW_DAY: "PA Penalty Allow Day",

			LBL_CUSTOMER_INTEREST_PENALTY_SC_TITLE: "SC (Service Charge)",
			LBL_CUSTOMER_INTEREST_PENALTY_SC_MODE: "SC Penalty Mode",
			LBL_CUSTOMER_INTEREST_PENALTY_SC_RATE: "SC Penalty Rate",
			LBL_CUSTOMER_INTEREST_PENALTY_SC_TERMS_DAY: "SC Penalty Terms Day",
			LBL_CUSTOMER_INTEREST_PENALTY_SC_ALLOW_DAY: "SC Penalty Allow Day",

			LBL_CUSTOMER_INTEREST_PENALTY_TA_TITLE: "TA (TAX)",
			LBL_CUSTOMER_INTEREST_PENALTY_TA_MODE: "TA Penalty Mode",
			LBL_CUSTOMER_INTEREST_PENALTY_TA_RATE: "TA Penalty Rate",
			LBL_CUSTOMER_INTEREST_PENALTY_TA_TERMS_DAY: "TA Penalty Terms Day",
			LBL_CUSTOMER_INTEREST_PENALTY_TA_ALLOW_DAY: "TA Penalty Allow Day",

			LBL_CUSTOMER_CTOS_CTOS_DATE: "CTOS Date",
			LBL_CUSTOMER_CTOS_CTOS_ACCOUNT: "CTOS ACC",
			LBL_CUSTOMER_CTOS_MONITORING_DATE: "Monitoring Date",
			LBL_CUSTOMER_CTOS_ETR_SUBMISSION_DATE: "eTR Submission Date",

			TAB_TITLE_ADDRESS: "Address",
			TAB_TITLE_CONTACT: "Contact",
			TAB_TITLE_MARKING_BILLING: "Marking Billing",
			TAB_TITLE_PREFERENCE: "Preference",
			TAB_TITLE_CREDIT_CONTROL: "Credit Control",
			TAB_TITLE_NOTE: "Note",
			TAB_TITLE_TRANSACTION_DESC: "Transaction Desc",
			TAB_TITLE_INTEREST_PENALTY: "Interest Penalty",
			TAB_TITLE_CTOS: "CTOS",
			TAB_TITLE_NEW_MARKING: "New Marking",

			MODULE_NAME: "Customer",
			CUSTOMER_MARKING_MODULE_NAME: "Customer Marking",

			BTN_CREATE_NEW_CUSTOMER_MARKING: "New Marking",
			BTN_SAVE_NEW_CUSTOMER_MARKING: "Save New Marking",

			COL_AGENT: "Agent",
			COL_COMPANY: "Company",
			COL_MAINSALESMAN: "Main Salesman",
			COL_SALESMAN: "Salesman",
			COL_NAME: "Name",
			COL_EMAIL: "Email",
			COL_MARKING: "Marking",
			COL_MARKING_STATUS: "Marking Status",
			COL_FULL_MARKING: "Full Marking",
			COL_NOTICE_TYPE: "Notice Type",

			DESC_CUSTOMER_MARKING_BILLING_ADD_ALT_EMAIL: "Able to enter multiple email by semicolon(;), etc:gim_admin@gim.com;gim_admin2@gim.com;gim_admin3@gim.com",

			MESSAGE_SWITCH_NEW_MARKING_TAB: "Current marking info changes will lose. (Ignore if you didn't make any changes or saved)",

			CUSTOMER_EMAIL_EXISTS: "Customer Login email exists",
			CUSTOMER_NAME_EXISTS: "Partner Name exists",
			NRICORBRN_EXISTS: "Nric / Brn exists",
			CUSTOMER_MARKING_UNIQUE_ERROR: "Marking must be unique for same company group"
		},
		DELIVERY_ADDRESS: {
			LISTING_TITLE: "Delivery Address Listing",
			CREATE_TITLE: "Create New Delivery Address",
			DETAIL_TITLE: "Delivery Address Detail",
			EDIT_TITLE: "Edit Delivery Address Detail",
			MODULE_NAME: "Delivery Address",

			TITLE_DELIVERY_ADDRESS_BASIC_INFO: "Basic Information",
			TITLE_DELIVERY_ADDRESS_ADDRESS_AND_INFO: "Delivery Address & Contact Info",
			TITLE_DELIVERY_ADDRESS_SETTINGS: "Settings",

			LBL_DELIVERY_ADDRESS_DELIVERY_ID: "Delivery Address Id",
			LBL_DELIVERY_ADDRESS_DELIVERY_ADDRESS_DESCRIPTION: "Name/Company name",
			LBL_DELIVERY_ADDRESS_DEFAULT_BILLING: "Default Billing Address ?",
			LBL_DELIVERY_ADDRESS_MARKING: "Marking",
			LBL_DELIVERY_ADDRESS_CUSTOMER: "Customer",
			LBL_DELIVERY_ADDRESS_PAYMENT_TYPE: "Payment Type",
			LBL_DELIVERY_ADDRESS_NOTICE_TYPE_ID: "Notice Type ID",
			LBL_DELIVERY_ADDRESS_PRINT_ADDRESS_IN_INVOICE: "Print Address In Invoice",
			LBL_DELIVERY_ADDRESS_PRINT_DELIVERY_ADDRESS: "Print Delivery Address",
			LBL_DELIVERY_ADDRESS_CONTACT_NAME: "Contact Name",
			LBL_DELIVERY_ADDRESS_CONTACT_EMAIL: "Email",
			LBL_DELIVERY_ADDRESS_CONTACT_WEBSITE: "Contact Website",
			LBL_DELIVERY_ADDRESS_BUILDING_NAME: "Building Name",
			LBL_DELIVERY_ADDRESS_ADDRESS: "Address",
			LBL_DELIVERY_ADDRESS_POSTCODE: "Postcode",
			LBL_DELIVERY_ADDRESS_OTHER_POSTCODE: "Other Postcode",
			LBL_DELIVERY_ADDRESS_CITY: "City",
			LBL_DELIVERY_ADDRESS_OTHER_CITY: "Other City",
			LBL_DELIVERY_ADDRESS_STATE: "State",
			LBL_DELIVERY_ADDRESS_COUNTRY: "Country",
			LBL_DELIVERY_ADDRESS_TEL_NO: "Office Contact No",
			LBL_DELIVERY_ADDRESS_TEL_PIC: "Office Contact Person In Charge",
			LBL_DELIVERY_ADDRESS_TEL_NO_WITH_PIC: "Tel No + PIC",
			LBL_DELIVERY_ADDRESS_MOBILE_NO: "Mobile Contact No",
			LBL_DELIVERY_ADDRESS_MOBILE_PIC: "PIC (MOBILE)",
			LBL_DELIVERY_ADDRESS_MOBILE_NO_WITH_PIC: "Mobile No + PIC",
			LBL_DELIVERY_ADDRESS_FAX_NO: "Fax No",
			LBL_DELIVERY_ADDRESS_RECEIVING_HOUR: "Receiving Hour",
			LBL_DELIVERY_ADDRESS_REMARK_ID: "Delivery Remark",
			LBL_DELIVERY_ADDRESS_REMARK: "Remark",
			LBL_DELIVERY_ADDRESS_USE_CUSTOMER_DO: "Use Customer DO ?",
			LBL_DELIVERY_ADDRESS_CUSTOMER_DO_HEADER_ID: "Customer Do Header ID",
			LBL_DELIVERY_ADDRESS_RESHIP: "Reship?",
			LBL_DELIVERY_ADDRESS_EXP_FORWARDER_ID: "Exp Forwarder ID",
			LBL_DELIVERY_ADDRESS_FORWARDER_COSTING_TYPE: "Forwarder Costing Type",
			LBL_DELIVERY_ADDRESS_AUTHORISED_LETTER: "Authorised Letter ?",
			LBL_DELIVERY_ADDRESS_HAS_ESYSTEM_ID: "Has E-System ID ?",
			LBL_DELIVERY_ADDRESS_GO_UPSTAIRS: "Go Upstairs ?",
			LBL_DELIVERY_ADDRESS_UPSTAIRS_COSTING_TYPE: "U/P Costing Type",
			LBL_DELIVERY_ADDRESS_FOLLOW_DELIVERY_ID_DUE_DAY: "Follow Delivery ID Due Day ?",
			LBL_DELIVERY_ADDRESS_DUE_DAYS: "Due Days",
			LBL_DELIVERY_ADDRESS_BY_AIR_SPECIAL_BILLING: "By Air Special Billing ?",
			LBL_DELIVERY_ADDRESS_BRN: "NRIC / BRN",
			LBL_DELIVERY_ADDRESS_MOBILE_NO_ALT: "Mobile Contact No (Alt)",
			LBL_DELIVERY_ADDRESS_MOBILE_NO_ALT_PIC: "Mobile Contact (Alt) Person In Charge",
			LBL_DELIVERY_ADDRESS_CUSTOMER_NAME: "Customer Name",
			LBL_DELIVERY_ADDRESS_RECEIVING_DAY: "Receiving Day",
			LBL_DELIVERY_ADDRESS_RECEIVING_REMARK: "Receiving Time Remark",

			COL_DELIVERY_ID: "Delivery ID",
			COL_CUSTOMER_NAME: "Customer Name",
			COL_MARKING: "Marking",
			COL_CODE: "Code",
			COL_NAME: "Name",
			COL_COMPANY_NAME: "Delivery Address Description / Company Name",
			COL_COMPANY_GROUP: "Company Group",
			COL_MSM_NAME: "Main Salesman",
			COL_SM_NAME: "Salesman",
			COL_EMAIL: "Email",
			COL_CONTACT_NO: "Mobile Contact No",
			COL_MOBILE_PIC: "Person In Charge",
			COL_UPSTAIRS: "Upstairs?",
			COL_COUNTRY: "Country",
			COL_STATE: "State",
			COL_CITY: "City",
			COL_POSTCODE: "Postcode",
			COL_DELIVERY_ADDRESS: "Delivery Address",

			PH_RECEIVING_HOUR_FROM: "-- Receiving Hour From --",
			PH_RECEIVING_HOUR_TO: "-- Receiving Hour To --",

			PH_RECEIVING_DAY_FROM: "-- Receiving Day From --",
			PH_RECEIVING_DAY_TO: "-- Receiving Day To --",

			DELIVERY_ID_VALIDATION: {
				DELIVERY_ID_LENGTH: "Must be {min} to {max} character.",
				DELIVERY_ID_SPECIAL_CHARACTER: "Allow {len} special character({special_character}) character only/Any alphanumeric character.",
				DELIVERY_ID_UNIQUE: "Delivery ID is available"
			},

			MSG_MARKING_ID_SAVE_AS_DELIVERY_ID: "Delivery Id will be assign after 1st marking id generated.",
			MSG_CANNOT_EDIT__DELIVERY_ID_MARKING: "Delivery Id assigned with 1st marking id generated. You not allow to edit",
			MSG_BLOCK_UPDATE_DELIVERY_ID: "Delivery Id used in Quotation/EPO, you are not allow to edit",
			MSG_BLOCK_UPDATE_COUNRTY_STATE_ID: "Delivery Address used in Quotation/EPO, you are not allow to edit country/state."
		},
		CUSTOMER_DO_HEADER: {
			LISTING_TITLE: "Customer Do Header Listing",
			CREATE_TITLE: "Create New Customer Do Header",
			DETAIL_TITLE: "Customer Do Header Detail",
			EDIT_TITLE: "Edit Customer Do Header Detail",

			TITLE_CUSTOMER_DO_HEADER_BASIC_INFO: "Basic Information",
			TITLE_CUSTOMER_DO_HEADER_ADDRESS_AND_INFO: "Address & Contact",

			LBL_CUSTOMER_DO_HEADER_CODE: "Do Header Code",
			LBL_CUSTOMER_DO_HEADER_NAME: "Customer Name",
			LBL_CUSTOMER_DO_HEADER_BUILDING_NAME: "Building Name",
			LBL_CUSTOMER_DO_HEADER_ADDRESS: "Address",
			LBL_CUSTOMER_DO_HEADER_POSTCODE: "Postcode",
			LBL_CUSTOMER_DO_HEADER_CITY: "City",
			LBL_CUSTOMER_DO_HEADER_STATE: "State",
			LBL_CUSTOMER_DO_HEADER_COUNTRY: "Country",
			LBL_CUSTOMER_DO_HEADER_FAX_NO: "Fax No",
			LBL_CUSTOMER_DO_HEADER_WEBSITE: "Website",
			LBL_CUSTOMER_DO_HEADER_DO_NUMBER_FORMAT: "Do Number Format",
			LBL_CUSTOMER_DO_HEADER_REMARK: "Remark",
			LBL_CUSTOMER_DO_HEADER_CONTACT_EMAIL: "Email",
			LBL_CUSTOMER_DO_HEADER_MOBILE_NO: "Mobile Contact No",
			LBL_CUSTOMER_DO_HEADER_CONTACT_NAME: "Mobile Contact PIC Name",
			LBL_CUSTOMER_DO_HEADER_MOBILE_NO_ALT: "Mobile Alt Contact No",
			LBL_CUSTOMER_DO_HEADER_MOBILE_NO_ALT_PIC: "Mobile Alt Contact PIC Name",
			LBL_CUSTOMER_DO_HEADER_TEL_PIC: "Office Tel PIC Name",
			LBL_CUSTOMER_DO_HEADER_TEL_NO: "Office Tel No",
			LBL_CUSTOMER_DO_HEADER_CONTACT_PIC: "Contact Pic",
			LBL_CUSTOMER_DO_HEADER_CONTACT_NO: "Contact No",
			LBL_CUSTOMER_DO_HEADER_CONTACT_WEBSITE: "Website",

			CUSTOMER_DO_HEADER_CODE_EXISTS: "Do Header Code Exists",

			MODULE_NAME: "Customer Do Header",

			COL_CODE: "Do Header Code",
			COL_NAME: "Customer Name",
			COL_CUSTOMER_EMAIL: "Customer Email",
			COL_DO_NUMBER_FORMAT: "DO Number Format",
			COL_COUNTRY: "Country",
			COL_STATES: "States",
			SELECTION: {
				DOC_NUM_A: "Doc Num A",
				DOC_NUM_B: "Doc Num B"
			}
		}
	},
	LOADING_MANAGEMENT: {
		REOPEN_TIME: "ReOpen Time",
		CLOSE_TIME: "Close Time",
		HAS_REOPEN_SO: "Has Reopen S/O",
		EXITS_REF_ID: "Exists Ref Id",
		REOPEN_REMARK: "ReOpen Remark",
		CLOSE_REMARK: "Close Remark",
		CLOSED_BY: "Closed By",
		REOPEN_BY: "Reopened By",
		EXISTS_FULL_MARKING: "Exists Full Marking",
		RECEIVE_PAYMENT: "S/O Rcv Payment"
	},
	LOAD_CONTAINER: {
		LBL_OPEN_DATE: "Open Date",
		LBL_CLOSE_DATE: "Closed Date",
		MSG: {
			CONFIRM_DEL_ALL_LOADED_ITEM: "All loaded order detail(s) will be deleted."
		},
		CONTAINER: {
			MENT_NAME: "Ref Id Details",
			LISTING_TITLE: "Ref Id Listing",
			CREATE_TITLE: "Create New Ref Id",
			DETAIL_TITLE: "Ref Id Detail",
			EDIT_TITLE: "Edit Ref Id Detail",
			DATE: "Date",
			PH_ENTER_INQUIRY_DATE_FROM: "Enter Date From",
			PH_ENTER_INQUIRY_DATE_TO: "Enter Date To",

			COUNTRY: "Destination Country",
			ORIGIN_COUNTRY: "Origin Country",
			LOADED_DATE: "Loaded Date",
			REF_ID: "Ref ID",
			SHIPMENT_MODE: "Shipment Mode",
			STANDARD: "Standard",
			S_TYPES: "Shipment Type",
			S_TERMS: "Shipment Term",
			DELIVERY_ZONE: "Delivery Zone",
			ED: "ED",
			EA: "EA",
			LPT: "LPT",
			DP: "DP",
			TTL_M: "TTL M",
			TTL_C: "TTL C",
			TTL_W: "TTL W",
			LNO: "LNo",
			REMARKS: "Remarks",
			RUNNING_NO_FORMAT: "Running No. Format",
			DIRECT: "Direct",
			CT_NO: "CT NO.",
			CT_TYPE: "CT TYPE",
			MARKING: "MARKING",
			CT_DESC: "CT Desc",
			RG_ID: "RG ID",
			FR_ID: "FR ID",
			SID: "SID",
			SHP_NA: "SHP NA",
			SL_ID: "SL ID",
			CID: "CID",
			FID: "FID",
			VSL_NO: "VSL NO.",
			VSL_NA: "VSL NA",
			FT_DET: "FT-DET",
			FT_DEM: "FT-DEM",
			BL_DATE: "BL DATE",
			L_DATE: "L. DATE",
			CY_DATE: "CY DATE",
			ED_DATE: "ED DATE",
			EA_DATE: "EA DATE",
			TOTAL_CTNS: "TTL C",
			TOTAL_M3: "TTL M",
			TOTAL_G_W: "TTL G",
			TOTAL_N_W: "TOTAL N W",
			TOTAL_AMT: "TOTAL AMT",
			L_BY: "L BY",
			DPT: "DPT",
			DELI_CITY: "DELI CITY",
			SNO1: "SNO.1",
			SNO2: "SNO.2",
			BL_NO: "BL NO",
			TLX_NO: "TLX NO.",
			FAD: "FAD",
			FDD: "FDD",
			ADD: "ADD",
			AAD: "AAD",
			PICK_DATE: "PICK DATE",
			LK_NO: "LK NO.",
			TRS_HP: "TRS HP",
			TRUCK1: "TRUCK 1",
			TRUCK2: "TRUCK 2",
			SHIPMENT: "Shipment"
		},
		LOADING: {
			MODULE_NAME: "Loading",
			LOADED_DATE: "Loaded Date",
			STATUS: "Status",
			TOTAL_ITEM: "Items",
			CTN: "CTN",
			KG: "Kg",
			M3: "M3",
			LOADED_AMOUNT: "Load Amount",
			LOADED_QTY: "Load QTY",
			DISCOUNT: "Discount",
			DEPOSIT: "Deposit",
			SUPPLIER_DEPOSIT: "Supplier Deposit",
			FCP_AMOUNT: "FCP Amount",
			MY_PAID_AMOUNT: "My Paid Amount",
			CASH_PAYMENT: "Cash Payment",
			ADD: "Add",
			TOTAL_QUANTITY: "Total Quantity",
			TOTAL_AMOUNT: "Total Amount",
			MARKED_UP_M3: "Marked Up CM3",
			CUSTOMER_M3: "CM3",

			DETAILS: {
				TOTAL_CTN: "Total Ctn",
				TOTAL_M3: "Total M3",
				ADD: "Add",
				MARKING: "Marking",
				DELIVERY_ID: "Delivery ID",
				LINE: "Line",
				LOADED_QTY: "Loaded Qty",
				LOAD_QTY: "Load Qty",
				BALANCE_QTY: "Bal Qty",
				QTY_PER_PACK: "Qty Per Pack",
				BUYING_PRICE: "Buying Price",
				LOAD_AMOUNT: "Load Amount",
				LOADED_AMT: "Loaded Amount",
				BALANCE_AMT: "Bal Amount",
				CTN: "Ctn",
				KG: "Kg",
				M3: "M3",
				WH_DISCOUNT: "Warehouse Discount",
				DISCOUNT: "Discount",
				CASH_PAYMENT: "Cash Payment",
				DEPOSIT: "Deposit",
				SUPPLIER_DEPOSIT: "Supplier Deposit",
				MY_PAID: "My Paid",
				FCP_AMOUNT: "Fcp Amount",
				DCP_AMOUNT: "Dcp Amount",
				RECEIVE_DATE: "Receive Date",
				CTN_NO: "CTN No",
				RECEIVE: "Receive",
				REC_BAL: "Loaded QTy",
				LOADED: "Load",
				LINE_NUMBER: "Line No",

				VOL_WEIGHT: "Volume Weight",
				MARKED_UP_M3: "Marked Up M3",
				BALANCE_CTN: "Bal ctn",
				BALANCE_M3: "Bal m3",
				BALANCE_KG: "Bal kg"
			},
			MSG: {
				SO_FULL_LOADED: "S/O Fully Loaded OR Not Found.",
				CONTAINS_DO: "Part of Loaded S/O was created D/O. You are not allow to delete.",
				MISS_ADD_SO: "Loading Detail is required",
				DETAIL_NOT_ENTER: "Please make sure Load Qty, Load Amt, kg, ctn or m3 have enter correct value ",
				EMPTY_CTN_CONFIRMATION: "Some of the ctn fields are empty, continue save?",
				REF_ID_EXISTS: "Selected Ref Id is already used, please select another.",
				ORDER_RECEIVE_DETAIL_NOT_FOUND: "Selected SO Received record not found, might have been updated.",
				RETRY_ORDER_RECEIVE_DETAIL: "Please try to remove and reselect the highlighted rows.",
				M3_ZERO_OR_MORE: "M3 must be 0 or more",
				INSUFFICIENT_BALANCE: "{dimension_field} ({value}) cannot exceed balance ({balance_value})",
				ORDER_RECEIVE_DETAIL_EXISTS: "This item (Ref No: {ref_no}, Line No: {line_no}) is already loaded. Please remove/ unselect it first."
			}
		},
		CLOSE: {
			MENT_NAME: "Close Receiving & Loading",
			LISTING_TITLE: "Close Receiving & Loading Listing",
			CREATE_TITLE: "Create New Close Receiving & Loading",
			DETAIL_TITLE: "Close Receiving & Loading",
			EDIT_TITLE: "Edit Close Receiving & Loading",
			DATE: "Date",
			PH_ENTER_INQUIRY_DATE_FROM: "Enter Loaded Date From",
			PH_ENTER_INQUIRY_DATE_TO: "Enter Loaded Date To",
			S_TYPES: "S. Type",

			REF_ID: "Ref Id",
			LOADED_DATE: "Loaded Date",
			STATUS: "Status",
			OPEN: "Open",

			DO_EXISTS: "D/O Exists"
		},
		OPEN: {
			MODULE_NAME: "Reopen Receiving & Loading",
			LISTING_TITLE: "Reopen Receiving & Loading Listing",

			DATE: "Date",
			S_TYPES: "S. Type",

			REF_ID: "Ref Id",
			LOADED_DATE: "Loaded Date",
			STATUS: "Status",
			OPEN: "Open",
			DO_EXISTS: "D/O Exists",

			OPEN_LOADING_TITLE: "Open {ref_id} Ref Id."
		},
		REOPEN_SO: {
			MODULE_NAME: "ReOpen S/O",
			OPEN_STATUS: "ReOpen S/O?",
			OPEN_SO_TITLE: "ReOpen Ref ID: {ref_id} S/O. (S/O No: {so_no})",

			UNLOAD_QUANTITY: "Unload Qty",

			MSG_BLOCK_OPEN_SO: "S/O No.: {so_no}, Ref Id({ref_id}) is open.",
			MSG_BLOCK_DELETE_REF: "S/O No.: {so_no} loading was deleted. (Ref Id: {ref_id})",
			MSG_BLOCK_DO: "S/O No.: {so_no}, D/O was exists in Ref Id ({ref_id}).",
			MSG_BLOCK_SO_NOT_FULLY_LOADED: "S/O No.: {so_no} not full loaded.",
			MSG_BLOCK_SO_EMPTY_LOAD_ID: "S/O No.: {so_no} does not have loading id."
		},
		CLOSE_REOPEN_SO: {
			MODULE_NAME: "Close ReOpen S/O",
			REF_ID: "Ref Id",
			RECEIVE_DATE: "Receive Date",
			REOPEN_DATE: "ReOpen Date",
			OPEN: "Open?",
			CLOSE: "Close",
			PLEASE_SELECT_DATA: "Please select data",
			CONTAINER_LOADING_DETAIL_HAS_DO: "DO exists",
			CONTAINER_IS_OPEN: "SO is in open container(s)",
			NOT_FULLY_LOADED: "SO is not fully loaded"
		}
	},
	PAYABLES: {
		LISTING_TITLE: "Payable Listing",
		CREATE_TITLE: "Create Payable Notes",
		VIEW_TITLE: "View Payable Notes",
		EDIT_TITLE: "Edit Payable Notes",
		MODAL_TITLE: "Add Orders",
		PRINT_MODAL_TITLE: "Print Payable Notes / GRN Receipt",
		PRINT: "Print",
		MODULE_NAME: "Payable Notes",
		PAYMENT_STATUS: "Deposit Status",
		Q_NUMBER: "Q Number",
		REFERENCE_NO: "Payable Notes No.",
		SUPPLIER_CONTACT_NO: "Supplier Contact No.",
		DRIVER_NAME: "Driver Name",
		DRIVER_CONTACT_NO: "Driver Contact No.",
		RESOLVE_STATUS: "Resolve Status",
		RECEIVE_DATE: "Receive Date",
		GENERATE: "Generate",
		NOTICE_TYPE: "Notice Type",
		SUPPLIER_NAME: "Supplier Name",
		AMOUNT: "Amount",
		RECEIVED_AMOUNT: "Received Amount",
		PAY_AMOUNT: "Pay Amount",
		REMARK: "Remark",
		RESOLVE_STATUS_OPTION: {
			NORMAL: "Normal",
			RESOLVE_REQ: "Resolve Required",
			RESOLVED: "Resolved/Paid"
		},
		CUSTOMER_NAME: "Customer Name",
		MARKING: "Marking",
		MAIN_SALESMAN: "Main Salesman",
		SALESMAN: "Salesman",
		COMPANY: "Company",
		COMPANY_GROUP: "Company Group",
		AGENT: "Agent",
		ISSUE_DATE: "Issue Date",
		PH_ENTER_DATE_FROM: "From",
		PH_ENTER_DATE_TO: "To",
		SUPPLIER_CONTACT: "Supplier Contact",

		PAYABLE_AMOUNT: "Payable Amount",
		CREATED_BY: "Created By",
		CREATED_ON: "Payment Date",
		SO_NUMBER: "So Number",
		SUPPLIER_DEPOSIT: "Supplier Deposit",
		CUSTOMER_DEPOSIT: "Customer Deposit",
		CASH_PAYMENT: "Cash Payment",
		MY_PAID: "My Paid",
		DISCOUNT: "Discount",
		BALANCE: "Balance",
		RECEIVED_DATE: "Received Date",
		ORDER_AMOUNT: "Order Amount",
		CTN: "Ctn",
		BENE_NAME: "Bank Account Name",
		BENE_CONTACT: "Bene Contact No.",
		OFFICE_CONTACT: "Office Contact No.",
		BANK_NAME: "Bank Name",
		BANK_PIC_NAME: "Bank PIC",
		BANK_CONTACT: "Bank Contact No.",
		BENE_ADDRESS: "Bene Address",
		BANK_ADDRESS: "Bank Address",
		BANK_PROVINCE: "Bank Province",
		BANK_DISTRICT: "Bank District",
		SUPPLIER_PIC: "Supplier PIC",
		BENE_PIC: "Bene PIC",
		BENE_DETAIL: "Beneficiary Details",
		BANK_ACCOUNT: "Bank Account",
		PRINT_AGAIN: "Reprint",
		WAREHOUSE_CHARGES: "Sticker Fees",
		WAREHOUSE_CHARGES_PARTY: "Pay by Supplier?",
		WAREHOUSE_CHARGES_PAID_AMOUNT: "Paid Amount",
		WAREHOUSE_DISCOUNT: "Warehouse Discount",
		FCP: "FCP",
		DCP: "DCP",
		MISC_AMOUNT: "Customer total paid amount",
		PAYABLE_AMT: "Payable",
		DIMENSION: "M3",
		SAVE_BENE_DETAILS: "Save as new beneficiary info",
		BENE_MODAL_TITLE: "Bene Listing",
		PN_NO_GRN_NO: "Payable Notes / GRN No.",
		MSG: {
			CTN_COUNT_NOT_SET: "Carton count not found, please check in status inquiry",
			STICKER_FEE_NOT_SET: "Sticker fee not found, please check ctn count and sticker fee",
			BENE_BANK_NOT_FOUND: "No bank records found for supplier : {supplier}",
			DOCUMENT_NO_NOT_SET: "Payables Document Number/ GRN Receipt No for selected warehouse is not set",
			PAYABLE_NOTES_EMPTY: ". Payable Notes content is empty.",
			AMOUNT_CANNOT_NEGATIVE: "Payable amount cannot negative.",
			HAVE_CLOSED_TT: "*Closed TT"
		}
	},
	PAYABLES_PAYMENT: {
		LISTING_TITLE: "Payable Notes Payment List",
		ORDER_MODAL_TITLE: "Order Receiving Outstanding List",
		MODULE_NAME: "Payable Notes Payment",
		CREATE_PAYMENT: "Create Payable Notes Payment",
		EDIT_PAYMENT: "Edit Payable Notes Payment",
		PAYMENT_DETAILS: "Payable Notes Payment Detail",
		UNPAID_PAYABLES: "Payable Notes Unpaid List",
		PAYABLE_BADGE_NO: "Badge No.",
		WAREHOUSE_COUNTRY: "Warehouse Country",
		DUE_DAYS: "Due Date",
		LOCAL_PAYABLE_AMOUNT: "Local Payable ",
		PAID_AMOUNT: "Paid",
		LOCAL_PAID_AMOUNT: "Local Paid",
		OUTSTANDING_AMOUNT: "Outstanding",
		LOCAL_OUTSTANDING_AMOUNT: "Local Outstanding",
		PAY_AMOUNT_LOCAL: "Local Pay",
		BENE_ACCOUNT_HOLDER: "Acc Holder",
		BENE_ACCOUNT_NO: "Acc No",
		BENE_CONTACT_NO: "Contact",
		BENE_CONTACT_PIC: "PIC",
		RI_NO: "RI No.",
		SWIFT_CODE: "Swift code",
		BANK_NAME: "Bank Name",
		BANK_ADDRESS: "Bank Address",
		BENE_ADDRESS: "Bene Address",
		BANK_REMARK: "Bank Remark",
		DATE: "Payment Date",
		DEPOSIT_STATUS: "Deposit Status",
		ACTIVE_RATE_NOT_FOUND: "No active currency rate found. Please contact admin.",
		BENE_VISIBLE: "Show Bene Details",
		WAREHOUSE: "Warehouse",
		AGENT: "Agent",
		BLOCK_AMOUNT: "Blocked/Credit Note Issue amount",

		BENE_BANK: "Bene & Bank",
		TABLE: {
			SUPPLIER_DEPOSIT: "SO SUP Deposit",
			CUSTOMER_DEPOSIT: "SO CUS Deposit",
			CASH_PAYMENT: "Cash Payment",
			WAREHOUSE_DISCOUNT: "Sup WH Disc",
			DISCOUNT: "Discount Amt",
			MY_PAID: "My Paid",
			STICKER_FEES: "Sticker Fees",
			STICKER_FEES_PAID_AMOUNT: "Supplier pay Amt",
			PAYABLE_AMOUNT: "PN Amt",
			PAID_AMOUNT: "Paid PN Amt",
			PN_CANCEL_AMOUNT: "PN Cancelled Amt",
			BALANCE_PN_AMOUNT: "Balance PN Amt",
			PN_PAYMENT_AMOUNT: "PN Payment Amt",
			LOCAL_PN_PAYMENT_AMOUNT: "Local PN Payment Amt",
			PAYABLE_BADGE_NO: "Badge Number",
			PAYMENT_DATE: "Payment Date",
			DEPOSIT_STATUS: "Deposit Status",
			CURRENCY: "Currency",
			ORDER_RECEIVED_AMOUNT: "Order Receiving Amt",
			SUPPLIER_NAME: "Supplier Name",
			SUPPLIER_CONTACT: "Supplier Contact",
			DELIVERY_ID: "Delivery Id",
			RECEIVE_DATE: "Receive Date",
			DEPOSIT_AMOUNT: "Deposit Amt",
			BANK_ACC_NAME: "Bank Holder",
			BANK_ACC: "Bank Account",
			BANK_NAME: "Bank Name",
			BANK_PROVINCE: "Bank Province",
			BANK_DISTRICT: "Bank District",
			BANK_ADDRESS: "Bank Address"
		},
		VALIDATION: {
			PAY_AMOUNT: "Payment Amt",
			LOCAL_PAY_AMOUNT: "Local Payment Amt",
			ACCOUNT_HOLDER: "Bene Account Holder",
			ACCOUNT_NO: "Bene Account Number",
			BANK_NAME: "Bank Name",
			AGENT: "Please Select Agent",
			NO_RECORD_FOUND: "No record found. Due Date : {due_date}",
			NO_ACTIVE_RATE: "Daily rate is not set",
			PAYMENT_AMOUNT_CANNOT_ZERO: "Payment Amount must be larger than zero."
		}
	},
	SYSTEM_LOG: {
		BACKEND_API_LOG_TITLE: "Backend Api Log",
		GIM_API_LOG_TITLE: "Gim Api Log",
		EMAIL_LOG_TITLE: "Email Log",
		ORDER_RECEIVE_LOG_TITLE: "Order Receive Log",
		SYNC_GIM_LOG_TITLE: "Sync To Gim Log",
		LOG_TITLE: "Log Result",

		LBL_LOG_DATE: "Log Date",
		LBL_LOG_DATE_FROM: "Date From",
		LBL_LOG_DATE_TO: "Date To",
		LBL_ERROR_CODE: "Error Code",
		COL_LOG_DATE: "Log Date",
		COL_REQUEST_PATH: "Path",
		COL_REQUEST_METHOD: "Method",
		COL_MSG: "Message",
		COL_RESULT: "Result",
		COL_ERROR_CODE: "Error Code"
	},
	EMAIL_LOG: {
		TITLE: "Email Log",
		EMAIL_MESSAGR_TITLE: "Email Message/Error Message",
		EMAIL_SUCCESS_MESSAGE: "Email resent successfully.",
		EMAIL_WARNING_MESSAGE: "Please select at least one email log.",
		LBL_SENT_DATE: "Sent On",
		LBL_SENT_TO: "Sent To",

		PORTAL_CUSTOMER: "Customer",
		PORTAL_ADMIN: "Admin",

		COL_SENT_ON: "Sent On",
		COL_SENT_TO: "Sent To",
		COL_SUBJECT: "Subject",
		COL_SENT_STATUS: "Sent Status",
		COL_SENT_ERROR_CODE: "Error Code",
		COL_PORTAL: "Portal",

		SENT_STATUS: {
			SENT: "Sent",
			FAILED: "Failed"
		}
	},
	ORDER_RECEIVE_LOG: {
		SO_NUMBER: "S/O No.",
		DATA: "Data",
		ACTION: "Action",
		USERNAME: "User Name",
		ACTION_SELECTION: {
			CREATE: "Create",
			EDIT: "Edit",
			CHANGE_SO: "Change SO",
			ALL: "ALL"
		},
		ORDER_RECEIVE_LOG_MESSAGE: "Message",
		ORDER_ID: "Order Receive Id",
		UPDATED_AT: "Log Date"
	},
	PRINT: {
		REPORT: {
			PACKING_LIST_BY_MSM_TITLE: "Packing List By Main Salesman",
			SWITCH_TRANSIT_ORDER: "Switch Transit Order"
		},
		PACKING_LIST: {
			LISTING_TITLE: "Packing List",
			PRINT_LISTING_TITLE: "Print Packing List",
			REPORT_TYPE: "Report Type",
			REPORT_FILTER: "Report Filter",
			REPORT_OPTIONS: "Report Options",
			SELECT_REF_ID: "Select Ref Id",
			MSG: {
				NO_RECORD: "No Record Found."
			}
		},
		START_STOCK_BALANCE: {
			LISTING_TITLE: "Stock Balance Report with Payment Info",
			PRINT_LISTING_TITLE: "Print Stock Balance Report with Payment Info",
			EXCL_FULL_PAY: "Exclude Fully Paid By Deposit and My Payment",
			SHOW_NEW_PAGE_FOR_NEW_MARKING: "Show new page for new marking",
			EXCL_TRANSIT_ORDER: "Excl. Transit Order",
			OR_DATE: "O/R Date",
			LOADED_DATE: "Loaded As At",
			REPORT_TYPE: "Report Type",
			REPORT_FILTER: "Report Filter",
			REPORT_OPTIONS: "Report Options",
			BY_WAREHOUSE_LISTING_TITLE: "Stock Balance Report By Warehouse",
			MSG: {
				NO_RECORD: "No Record Found."
			}
		},
		ORDER_RECEIVE_SUMMARY: {
			LISTING_TITLE: "Order Receving Summary",

			LBL_CREDIT_PAYMENT: "Credit Payment",

			REPORT_FILTER: {
				OUTSTANDING: "Outstanding",
				FULL_PAYMENT: "Full Payment",
				ALL: "All (Outstanding + Full Payment)"
			}
		}
	},
	TT: {
		MODULE_NAME: "TT Request",
		BUTTON: {
			VERIFY: "Verify",
			APPROVE: "Approve",
			ACKNOWLEDGE: "Acknowledge",
			ASSSIGN: "Assign",
			REJECT_VERIFY: "Reject Verification",
			REJECT_APPROVE: "Reject Approval",
			REJECT_ACKNOWLEDGE: "Reject Acknowledgement",
			REJECT_ASSSIGN: "Reject Assignment",
			REQUEST_AGAIN: "Request Again"
		},
		DEPOSIT_STATUS: {
			SAVE_AS_DRAFT: "Save as draft",
			PENDING_VERIFY: "Pending Verify"
		},
		PAGE: {
			REQUEST_INDEX_TITLE: "Request Listing",
			REQUEST_CREATE_TITLE: "Create New Request",
			VERIFY_TITLE: "Verify Listing",
			ACKNOWLEDGE_TITLE: "Acknowledge Listing",
			APPROVE_TITLE: "Approve Listing",
			VIEW_REQUEST_TITLE: "View Request",
			EDIT_REQUEST_TITLE: "Edit Request",
			VIEW_VERIFY_TITLE: "Verify Request",
			EDIT_VERIFY_TITLE: "Verify Request",
			VIEW_APPROVE_TITLE: "Approve Request",
			EDIT_APPROVE_TITLE: "Approve Request",
			VIEW_ACKNOWLEDGE_TITLE: "Acknowledge Request",
			EDIT_ACKNOWLEDGE_TITLE: "Acknowledge Request",
			BENE_DETAIL_TITLE: "Bene Details"
		},
		INDEX: {
			DEPOSIT_STATUS: "Deposit Status",
			TT_DATE: "TT Date",
			MAIN_SALESMAN: "Main Salesman",
			SALESMAN: "Salesman",
			MARKING: "Marking",
			COMPANY: "Company",
			TOTAL_TT_AMOUNT: "Total TT Amount",
			TOTAL_LOCAL_TT_AMOUNT: "Total Local TT Amount",
			TT_CHARGES: "TT Charges",
			TT_CATEGORY: "TT Category",
			ACKNOWLEDGE_DATE: "Acknowledged Date",
			CURRENCY: "Currency",
			WAREHOUSE_COUNTRY: "WH Country",
			REJECT_REASON: "Reject Reason"
		},
		HEADER_MODEL: {
			WAREHOUSE: "Warehouse",
			MARKING: "Marking",
			CURRENCY: "TT Currency",
			RATE: "Rate",
			ACCOUNT_TYPE: "Account Type",
			BENE_TYPE: "Bene Type",
			TT_CATEGORY: "TT Category",
			CUSTOMER_REMARK: "Customer Remark",
			AR_REMARK: "Admin Remark",
			OTHER_AMT: "Other Amount",
			OTHER_LOCAL_AMT: "Other Local Amount",
			WITHOUT_OR: "Without OR?",
			OR_AMOUNT: "OR Amount",
			ACTUAL_AMOUNT: "Actual Amount",
			FINANCE_P: "F-m/up(%)",
			TT_CHARGES_CURRENCY: "TT Charges Currency",
			TT_CHARGES: "TT Charges",
			EXT_TO_LOCAL: "Ext To Local",
			TOTAL_TT_AMT: "Total TT Amount",
			TOTAL_LOC_TT_AMT: "Total Local TT Amount",
			OUTGOING_CURRENCY: "Outgoing Currency",
			CONVERTED_RATE: "Converted Rate",
			OUTGOING_TT_AMT: "Outgoing TT Amount",
			OUTGOING_LOC_TT_AMT: "Outgoing Local TT Amount",
			ADD_EPO_SO: "Add EPO / Order Received",
			EPO_CURRENCY: "Epo Currency",
			ANOTHER_TT_CURRENCY: "Another TT Currency?",
			PAYABLE_BADGE_NO: "Payable Notes Badge No",
			AP_REMARK: "AP Remark"
		},
		BENE_MODEL: {
			BENE_TITLE: "Beneficiary Details",
			ACC_HOLDER: "Account Holder",
			ACC_NO: "Account Number",
			BENE_CONTACT_PIC: "Bene Contact PIC",
			BENE_CONTACT_CALLING_CODE: "Bene Calling Code",
			BENE_CONTACT_NO: "Bene Contact Number",
			RI_NO: "Ri Number",
			BANK_NAME: "Bank Name",
			BANK_CITY: "Bank City",
			BANK_COUNTRY: "Bank Country",
			BANK_ADDRESS: "Bank Address",
			BENE_ADDRESS: "Bene Address",
			BANK_REMARK: "Bank Remark",
			BANK_CODE: "BIC / Swift Code",
			IBAN: "IBAN"
		},
		DETAIL_MODEL: {
			EPO_NO: "EPO/SO",
			EPO_AMOUNT: "Epo Amount",
			PAY_AMOUNT: "Pay Amount",
			PAY_AMOUNT_LOCAL: "Local Pay Amount",
			ADJUSTMENT_INDICATOR: "+/-",
			ADJUSTMENT_AMOUNT: "Adjustment Amount",
			ADJUSTMENT_AMOUNT_LOCAL: "Local Adjustment Amount",
			REMARK: "Remark",
			OUTSTANDING_AMOUNT: "Outstanding Amount",
			CANCEL: "Cancel",
			ADD: "Add",
			SUBTOTAL: "Sub Total",
			SUBTOTAL_LOCAL: "Local Sub Total",
			AMOUNT_IN_PROCESS: "Amount In Process",
			RECEIVED_AMOUNT: "Received Amount",
			ALT_DEPOSIT: "TTed Amount ({mod})",
			ALT_APPLIED_ADJUSTMENT: "Applied TT Adjustment ({mod})",
			ALT_PAY_AMOUNT: "Pay Amount ({mod})",
			ALT_ADJUSTMENT_AMOUNT: "Adjustment Amount ({mod})",
			ALT_SUBTOTAL: "Sub Total ({mod})",
			IS_DEPOSIT: "Deposit/Payment",
			CURRENCY_CODE: "Currency Code",
			DATE: "Epo/Received Date",
			SUPPLIER_NAME: "Supplier Name",
			SHIPMENT_TYPE: "Shipment Type",
			GRAND_TOTAL: "Epo Amount/Received Amount",
			TTED_AMOUNT: "TTed Amount"
		},
		FOOTER_MODEL: {
			SUBMIT: "Submit",
			VERIFY: "Verify",
			APPROVE: "Approve",
			ACKNOWLEDGE: "Acknowledge",
			SAVE_AS_DRAFT: "Save As Draft",
			REJECT: "Reject",
			CANCEL: "Cancel"
		},
		ADD_EPO_SO: "Add EPO / Order Received (SO) ",
		VERIFY_REJECT: "Reject",
		APPROVE_REJECT: "Reject",
		ACKNOWLEDGE_REJECT: "Reject",
		VERIFY: "Verified",
		APPROVE: "Approved",
		ACKNOWLEDGE: "Acknowledged",
		DATE: "Date",
		EPO_NO: "Epo No",
		STATUS: "Status",
		MAIN_SALESMAN: "Main Salesman",
		SALESMAN: "Salesman",
		CURRENCY_CODE: "Currency Code",
		AMOUNT: "Amount",
		EPO_DATE: "Epo Date",
		CUSTOMER_NAME: "Customer Name",
		RECEIVE_DATE: "Receive Date",
		TTED_AMOUNT: "TTed Amount",
		TTED_AMOUNT_LOCAL: "Local TTed Amount",
		SUPPLIER_NAME: "Supplier Name",
		SHIPMENT_TYPE: "Shipment Type",
		DISCOUNT_AMOUNT: "EPO/SO Discount",
		APPLIED_TT_ADJUSTMENT: "Applied TT Adjustment",
		APPLIED_TT_ADJUSTMENT_LOCAL: "Local Applied TT Adjustment",
		FINAL_TT_AMOUNT: "Final TT Amount",
		FINAL_TT_AMOUNT_LOCAL: "Final Local TT Amount",
		CONFIRM: "Confirm",
		REJECT: "Reject",
		SO_MODULE: "Order Received",
		MSG_RATE_EXPIRED: "Currency rate effective time expired, TT request is prohibited",
		MSG_TT_CHARGES_NOT_FOUND: "Bank city is not set, tt charges is empty.",
		PAY_AMOUNT_CANNOT_EXCEED: "Pay amount cannot exceed outstanding amount",
		REJECT_REASON: {
			SELECT_REASON: "Reject reason",
			OTHER: "Other reason",
			PH_OTHER: "Please input other reason"
		},
		MAINTAIN_TT_DEPOSIT: {
			MODULE_NAME: "TT Deposit",
			LISTING_TITLE: "TT Deposit",
			COL: {
				AMOUNT: "Amount",
				DCP_AMOUNT: "Dcp Amount",
				SOURCE_ID: "Source Id",
				FROM_OIS: "From OIS",
				REMARK: "remark",
				RECEIVED_STATUS: "Received Status"
			},
			MSG: {
				IS_MISSING: "{label} is missing",
				CANNNOT_EDIT: "This record is from OIS, cannot be edited.",
				HAS_BEEN_RECEIVED: "This record has existing order receive records, cannot be deleted",
				CONTINUE_CONFIRMATION: "Are you sure to continue?",
				SAME_DATE_SO_NO: "TT Deposit with same date and SO No exists",
				CONFIRMATION_EXISTED_SO_NO: "S/O Order receiving record exists.<br />Are You Sure to continue TT Deposit?",
			},
			SOURCE_ID: "Source Id",
			AMOUNT: "Amount",
			DCP_AMOUNT: "Dcp Amount",
			TT_DEPOSIT: "TT Deposit",
			ID: "id",
			SO_NO: "so_no",
			BANK_NAME: "Bank Name",
			BANK_ACCOUNT_NAME: "Bank Account Name",
			BANK_ACCOUNT_NO: "Bank Account No",
			BANK_PROVINCE: "Bank Province",
			BANK_DISTRICT: "Bank District",
			BANK_ADDRESS: "Bank Address",
			RECEIVED: "Received",
			NOT_RECEIVED: "Not Received"
		}
	},
	GIMWORLD_ORDER: {
		MAINTENANCE: {
			MENT_NAME: "Gimworld Order Maintenance",
			LISTING_TITLE: "Gimworld Order Maintenance",
			DATE_FROM: "Enter Date From",
			FULL_MARKING: "Full Marking",
			DATE_TO: "Enter Date To",
			CREATION_DATE: "Creation Date",
			EDIT_SUCCESS: "Successfully modified",
			CREATION_DATE_FROM: "Creation Date From",
			CREATION_DATE_TO: "Creation Date To",
			IMPORT: "Import GimWorld Excel File",
			BATCH: "Batch ID",
			FILE: "File",
			ONLY_EXCEL_FILES_CAN_BE_UPLOADED: "Only excel files can be uploaded!",
			SHOW_POSTED: "Show Posted?",
			IMPORT_COMPLETED: "Import Completed!",
			POSTED: "Posted?",
			STOCK_MASTER_ID: "Stock ID",
			DATE: "Date",
			MARKING: "Marking",
			DELIVERY_ID: "Delivery ID",
			TRACKING_NO: "Tracking No",
			DESC: "Desc 1",
			DESC2: "Desc 2",
			QTY: "QTY",
			AMOUNT: "Amount",
			CTN: "Ctn",
			WEIGHT: "Weight",
			M3: "M3",
			DIMENSION: "Dimension",
			SHIPMENT_TYPE: "Shipment type",
			COUNTRY: "Country",
			STATE: "State",
			CITY: "City",
			CONSIGNEE: "Consignee",
			TEL_NO: "Tel no",
			POST_CODE: "Post Code",
			ADDRESS: "Address",
			REMARK: "Remark",
			WAREHOUSE: "Warehouse",
			MSG: {
				SO_NO_EXISTS: "Tracking No : {so_no} exists",
				DELETE_CONFIRMATION: "All items with same tracking no will be deleted.",
				INCORRECT_HEADER: "File has incorrect headers",
				MISSING_HEADER: "File has missing headers",
				INCORRECT_HEADER_CAPTION: 'Column {header_index} : "{header_name}" should be "{correct_header_name}" <br>',
				MISSING_HEADER_CAPTION: 'Missing Header "{header_name}" at Column {header_index} <br>',
				SETTINGS_UNDEFINED: "GIM World Settings Undefined. Please contact System admin.",
				HEADER_COLUMN_NOT_TALLY: "Column not matching",
				MSM_CODE_NOT_EXISTS: "Row: {index}, {msm_code} main salesman code not found. <br/>",
				SM_CODE_NOT_EXISTS: "Row: {index}, {sm_code} salesman code not found. <br/>",
				MARKING_NOT_EXISTS: "Row: {index}, {marking} marking not found <br />",
				DELIVERY_ID_NOT_EXISTS: "Row: {index}, {delivery_id} delivery id not found.<br />",
				DELIVERY_ZONE_NOT_EXISTS: "Row: {index}, Delivery Zone for {delivery_id} delivery id not found. <br />",
				SHIPMENT_TYPE_NOT_EXISTS: "Row: {index}, {shipment_type} shipment type is not found.<br />",
				UOM_NOT_EXISTS: "Row: {index}, {uom_code} uom is not found.<br />",
				PRODUCT_ID_DUPLICATE: "Row: {index}, {product_order_id} Product ID duplicate.<br />",
				SO_NO_DUPLICATE: "Row: {index}, {so_no} SO NO already exists.<br />"
			}
		},
		POST_ORDER: {
			MENT_NAME: "Post to Order Receiving",
			LISTING_TITLE: "Post to Order Receiving",
			CREATION_DATE: "Creation Date",
			EDIT_SUCCESS: "Successfully modified",
			SUCCESSFULLY_POST_TO_ORDER_RECEIVING: "Successfully post to Order Receiving!",
			CREATION_DATE_FROM: "Creation Date From",
			CREATION_DATE_TO: "Creation Date To",
			POST: "Post",
			BATCH: "Batch ID",
			SHOW_POSTED: "Show Posted?",
			IMPORT_COMPLETED: "Import Completed!",
			IMPORT_TO_LOADING: "Do you want to Post To Loading",
			IMPORT_TO_LOADING_TITLE: "Please Choose Warehouse and Ref ID",
			POSTED: "Posted?",
			STOCK_MASTER_ID: "Stock Master ID",
			DATE: "Date",
			TRACKING_NO: "Tracking No",
			DESC: "Desc 1",
			DESC2: "Desc 2",
			QTY: "QTY",
			AMOUNT: "Amount",
			CTN: "Ctn",
			WEIGHT: "Weight",
			M3: "M3",
			DIMENSION: "Dimension",
			SHIPMENT_TYPE: "Shipment type",
			COUNTRY: "Country",
			STATE: "State",
			CITY: "City",
			CONSIGNEE: "Consignee",
			TEL_NO: "Tel no",
			POST_CODE: "Post Code",
			ADDRESS: "Address",
			REMARK: "Remark",
			WAREHOUSE: "Warehouse",
			COURIER_AGENT: "Courier Agent",
			MSG: {
				MSM_CODE_NOT_EXISTS: "Main Salesman: {msm_code} not exists.",
				CUSTOMER_MARKING_NOT_FOUND: "Marking: {msm_code}/{sm_code}/{marking} not exists.",
				WAREHOUSE_COMPANY_GROUP_NOT_SET: "Warehouse: {warehouse_code}'s company group not set.",
				DELIVERY_ADDRESS_NOT_FOUND: "Delivery ID: {delivery_id} not exists.",
				SHIPMENT_TYPE_NOT_FOUND: "Shipment Type: {shipment_type} not exists",
				COURIER_COMPANY_NOT_FOUND: "Courier Company with courier agent: {courier_agent_code} and labels: {label} not exists",
				LABEL_IS_EMPTY: "Label cannot be empty",
				UOM_CODE_NOT_FOUND: "Uom: {uom_code} not exists",
				SO_NO_EXISTS: "Tracking No : {so_no} exists",
				PRODUCT_ID_EXISTS: "Product ID : {so_no} exists"
			}
		}
	},
	RESET_EMAIL_PASS: {
		TITLE: "Reset Login Details ",
		EMAIL: "Email",
		EMAIL_DESC: "Your Email",
		PASSWORD_DESC: "Your New Password",
		BUTTON_TEXT: "Reset Login",
		USERNAME: "Username"
	}
};
